import { useEffect, useRef, useState, useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useSocket from "../../services/socketService";
import ProspectTenantSearch from "./components/tenant-propect-search";
import ProspectList from "./components/prospectList";
import TenantList from "./components/tenantList";
import ProspectListunread from "./components/prospectListunread";
import TenantListunread from "./components/tenantListunread";
//import EmployeeList from "./components/employeeList";
//import EmployeeListunread from "./components/employeeListunread";
import ChatMessages from "./components/chat-messages";
import styles from "./communication-chat.module.css";
// ADD, alongside the other identity-chat imports
import AssignedTenantConversations from "./components/identity-chat/AssignedTenantConversations";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  IconButton,
  Slide,
  Snackbar,
  TextField,
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import {
  ChevronLeft,
  MoreVertical,
  Phone,
  PhoneCall,
  PhoneIncoming,
  Plus,
  Send,
  X,
  ArrowLeft,
  Edit,
  Trash2,
  Search,
} from "react-feather";
import ChatInputBox from "./components/chatInputBox";
import { toast } from "react-smart-toaster";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { communicationChatBoxOpen } from "../../redux/actions/communicationChatBoxAction";
import { communicationChatReload } from "../../redux/actions/communicationChatRloadAction";
import { resetConversationId } from "../../redux/actions/communicationConversationId";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { setVoiceCallInfo } from "../../redux/actions/communicationVoiceCallInfo";
import { communicationVoiceCallScreenOpen } from "../../redux/actions/communicationVoiceCallScreenAction";
import Prompts from "./components/prompts/prompts";
import PromptsForConversation from "./components/prompts/components/PromptListForConversation";
//import TwilioDownBanner from "./components/twilio-down-banner";
import CallForward from "./components/call-forwarding-numbers/CallForward";
import { Dropdown } from "react-bootstrap";
import CallDialer from "./components/callDialer";
// new import, alongside existing ones
import { Client as ConversationsClient } from "@twilio/conversations";
// new imports
import IdentityChatMessages from "./components/identity-chat/identityChatMessages";
import IdentityChatInputBox from "./components/identity-chat/identityChatInputBox";
import EmployeeGlobalList from "./components/identity-chat/employeeGlobalList";
import EmployeeGroupsUnread from "./components/identity-chat/employeeGroupsUnread";
import { initializeIdentityVoiceDevice } from "./components/identity-voice/identityVoiceService";
import IdentityVoiceCallBar from "./components/identity-voice/identityVoiceCallBar";
import IdentityIncomingCallModal from "./components/identity-voice/identityIncomingCallModal";
//import { placeIdentityVoiceCall } from "./components/identity-voice/identityVoiceService";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));
let identityClientInitCount = 0;
const CommunicationChat = () => {
  const socket = useSocket();
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const isCommunicationChatBoxOpen = useSelector(
    (store) => store.communicationChatBoxReducer
  );
  const isCommunicationChatReload = useSelector(
    (store) => store.communicationChatReloadReducer
  );
  const isConversationIdExist = useSelector(
    (store) => store.conversationIdReducer
  );
  const voiceCallInfo = useSelector(
    (store) => store.communicationVoiceCallInfoReducer
  );
  // alongside existing useSelector calls
  const userInfo = useSelector((store) => store.userInfoReducer);
  const isCurrentUserAdmin = userInfo?.role?.toLowerCase() === "admin";
  const dispatch = useDispatch();
  const [chatMessagesList, setChatMessagesList] = useState([]);
  const [tenantList, setTenantList] = useState([]);
  const [prospectList, setProspectList] = useState([]);
  //  const [employeeList, setEmployeeList] = useState([]);
  const [prospectTenantList, setProspectTenantList] = useState([]);
  const [isShowGlobalList, setIsShowGlobalList] = useState(false);
  const [isShowUnreadMessageList, setIsShowUnreadMessageList] = useState(true);
  const [isShowChatMessages, setIsShowChatMessages] = useState(false);
  const [isShowPropertyChatMessages, setIsShowPropertyChatMessages] = useState(
    false
  );
  const [prospectTenantDetails, setProspectTenantDetails] = useState(null);
  const [unreadMessageList, setUnreadMessageList] = useState([]);
  const [accordionOnForProspect, setaccordionOnForProspect] = useState(false);
  const [
    accordionOnForProspectUnRead,
    setaccordionOnForProspectUnRead,
  ] = useState(true);
  const [accordionOnForEmployee, setAccordionOnForEmployee] = useState(false);
  const [
    accordionOnForEmployeeUnRead,
    setAccordionOnForEmployeeUnRead,
  ] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState("");
  const [accordionOnForTenant, setaccordionOnForTenant] = useState(false);
  const [accordionOnForTenantUnRead, setaccordionOnForTenantUnRead] = useState(
    false
  );
  const [conversationList, setConversationList] = useState([]);
  const [unreadMessagesCounter, setUnreadMessagesCounter] = useState(0);
  const [messageTextVal, setMessageTextVal] = useState("");
  const [messageType, setMessageType] = useState("propertydek-message");
  const [
    typeaheadProspectTenantList,
    setTypeaheadProspectTenantList,
  ] = useState([]);
  const [messageLoader, setMessageLoader] = useState(false);
  const [prospectTenantNames, setProspectTenantNames] = useState([]);
  const [isShowCommunicationChat, setIsShowCommunicationChat] = useState(true);
  const [
    prospectTenantNamesForToolTip,
    setProspectTenantNamesForToolTip,
  ] = useState("");
  const [promptListForConversation, setPromptListForConversation] = useState(
    []
  );
  const messageLoaderRef = useRef(messageLoader);
  const chatMessagesListRef = useRef(chatMessagesList);
  const prospectTenantDetailsRef = useRef(prospectTenantDetails);
  const unreadMessagesCounterRef = useRef(unreadMessagesCounter);
  const prospectTenantListRef = useRef(prospectTenantList);
  const conversationListRef = useRef(conversationList);
  const unreadMessageListRef = useRef(unreadMessageList);
  const typeaheadProspectTenantListRef = useRef(typeaheadProspectTenantList);
  const location = useLocation();
  const firstPath = "/" + location.pathname.split("/")[1];
  const [openCallModal, setOpenCallModal] = useState(false);
  const [prospectInfoObj, setProspectInfoObj] = useState(null);
  const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);
  const [isCallForwardModalOpen, setIsCallForwardModalOpen] = useState(false);
  const [isShowPromptAddForm, setIsShowPromptAddForm] = useState(false);
  const [twilioDown, setTwilioDown] = useState(false);
  const [twilioStatusMsg, setTwilioStatusMsg] = useState("");
  const [openPromptforConversation, setOpenPromptforConversation] = useState(
    false
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [openCallDialer, setOpenCallDialer] = useState(false);
  // new state, alongside the existing useState block
  const [identityClient, setIdentityClient] = useState(null);
  const [identityClientReady, setIdentityClientReady] = useState(false);
  const [employeeDirectory, setEmployeeDirectory] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [activeIdentityConversation, setActiveIdentityConversation] = useState(
    null
  );
  const [isShowIdentityChatMessages, setIsShowIdentityChatMessages] = useState(
    false
  );

  // in-app message new state
  const [identityChatMessagesList, setIdentityChatMessagesList] = useState([]);
  const [identityMessageTextVal, setIdentityMessageTextVal] = useState("");
  const [identityMessageLoader, setIdentityMessageLoader] = useState(false);
  const [isOpeningIdentityChat, setIsOpeningIdentityChat] = useState(false);
  const [activeIdentityChatPartner, setActiveIdentityChatPartner] = useState(
    null
  );
  const [hasMoreOlderMessages, setHasMoreOlderMessages] = useState(false);
  const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false);
  const messagesPaginatorRef = useRef(null);
  const loadedMessageSidsRef = useRef(new Set());
  const [pendingAttachment, setPendingAttachment] = useState(null); // { file, name, type, previewUrl }
  const MAX_ATTACHMENT_SIZE = 50 * 1024 * 1024; // 50MB
  const [isUploadingAttachment, setIsUploadingAttachment] = useState(false);
  const [typingIdentities, setTypingIdentities] = useState([]);
  const identityClientRef = useRef(null);
  const lastTypingCallRef = useRef(0);
  const [isShowTeamTab, setIsShowTeamTab] = useState(false);
  const [identityVoiceDevice, setIdentityVoiceDevice] = useState(null);
  const [incomingIdentityCall, setIncomingIdentityCall] = useState(null);
  const identityVoiceDeviceRef = useRef(null);
  const hasInitializedIdentityVoiceRef = useRef(false);
  const [isRequestBasedAccess, setIsRequestBasedAccess] = useState(false);

  const [activeIdentityCall, setActiveIdentityCall] = useState(null);
  const [
    activeIdentityCallPartnerName,
    setActiveIdentityCallPartnerName,
  ] = useState("");

  const [
    activeIdentityCallPartnerIdentity,
    setActiveIdentityCallPartnerIdentity,
  ] = useState(null);
  const [
    activeIdentityCallPartnerAvatar,
    setActiveIdentityCallPartnerAvatar,
  ] = useState("");
  const activeIdentityCallPartnerIdentityRef = useRef(null);
  const [isOutgoingCall, setIsOutgoingCall] = useState(false);

  //in-app group states
  const [openGroupModal, setOpenGroupModal] = useState(false);
  const [
    openDeleteGroupConfirmModal,
    setOpenDeleteGroupConfirmModal,
  ] = useState(false);
  const [groupIdToDelete, setGroupIdToDelete] = useState(null);
  const [groupModalMode, setGroupModalMode] = useState("add"); // "add" | "edit"
  const [groupNameInput, setGroupNameInput] = useState("");
  const [groupNameError, setGroupNameError] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [editingGroup, setEditingGroup] = useState(null); // the group object being edited
  const [isSavingGroup, setIsSavingGroup] = useState(false);
  const [employeeGroupsUnreadList, setEmployeeGroupsUnreadList] = useState([]);
  const [employeeGroupsTotalUnread, setEmployeeGroupsTotalUnread] = useState(0);
  const [allEmployeesForNames, setAllEmployeesForNames] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const handleSearchToggle = () => {
    setShowSearch((prev) => !prev);
  };

  const allowedRoutes = [
    "",
    "/people",
    "/dashboard",
    "/properties",
    "/cases",
    "/leases",
    "/schedule",
    "/income/all-income",
    "/smart-devices",
    "/resources",
    "/logs",
    "/notifications",
    "/more",
    "/income",
    "/expense",
    "/reports",
    "/communication",
    "/notification",
    "/maintenance",
    "/request",
    "/security",
    "/pet",
    "/hr",
  ];
  const isChatVisible = allowedRoutes.includes(firstPath);

  const handleIdentityChatError = (error, context, fallbackUserMessage) => {
    const code = error?.code;
    const status = error?.status;
    const message = error?.message || error?.body?.message;

    if (status === 401 || code === 20003) {
      setSnackbarOpen(true);
      setSnackbarMsg("Chat session expired. Please refresh the page.");
      return "auth";
    }
    if (status === 403 || code === 20404) {
      setSnackbarOpen(true);
      setSnackbarMsg(
        "Chat access denied — this may be an account issue. Contact support if this persists."
      );
      return "forbidden";
    }
    if (code === 50200) {
      setSnackbarOpen(true);
      setSnackbarMsg(
        "One of the selected people hasn't been set up for chat yet."
      );
      return "user_not_found";
    }
    if (
      !identityClientRef.current ||
      identityClientRef.current.connectionState === "disconnected"
    ) {
      setSnackbarOpen(true);
      setSnackbarMsg(
        "Chat connection lost. Please check your connection and try again."
      );
      return "disconnected";
    }

    // setSnackbarOpen(true);
    // setSnackbarMsg(
    //   fallbackUserMessage || "Something went wrong. Please try again."
    // );
    return "unknown";
  };
  useEffect(() => {
    if (isAuthenticated) {
      getProspectTenantList();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setIsShowCommunicationChat(isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        console.log("Connected ");
        dispatch(communicationChatReload(true));
      });
    }
  }, [socket]);

  useEffect(() => {
    async function reloadChat() {
      try {
        if (isCommunicationChatReload) {
          const r = await getProspectTenantList();

          if (prospectTenantDetailsRef.current && prospectTenantList.length) {
            const value = prospectTenantDetailsRef.current;

            // const findTenantProspect = prospectTenantList.find(
            //   (pt) => pt.conversation_id === value.conversation_id
            // );
            const findTenantProspect = prospectTenantListRef.current.find(
              (pt) => pt.conversation_id === value.conversation_id
            );

            if (findTenantProspect) {
              setDetails(findTenantProspect);
            } else {
              backToList();
            }
            const findPropectTenantName = typeaheadProspectTenantListRef.current.filter(
              (pt) => value.conversation_id === pt.conversation_id
            );

            setProspectTenantNames(findPropectTenantName);
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    reloadChat();
  }, [isCommunicationChatReload]);

  useEffect(() => {
    if (isConversationIdExist) {
      const findTenantProspect = prospectTenantList.find(
        (pt) => pt.conversation_id === isConversationIdExist
      );

      if (findTenantProspect) {
        setDetails(findTenantProspect);
        dispatch(communicationChatBoxOpen(true));
      }
    }
  }, [isConversationIdExist]);

  useEffect(() => {
    const checkTwilioStatus = async () => {
      try {
        const url = process.env.REACT_APP_TWILIO_URL;
        const res = await axios.get(url);
        const components = res.data.components;

        // Define the services to monitor
        const servicesToCheck = [
          { name: "CONVERSATIONS", label: "Conversations" },
          { name: "PROGRAMMABLE MESSAGING", label: "Messaging" },
        ];

        // Define severity ranking
        const severityRank = {
          operational: 0,
          degraded_performance: 1,
          partial_outage: 2,
          major_outage: 3,
        };

        const statusMap = {
          degraded_performance: "Twilio messaging may be slower than usual.",
          partial_outage: "Twilio messaging is partially unavailable.",
          major_outage: "Twilio messaging is currently down.",
        };

        let worstStatus = "operational";
        let worstService = "";

        for (let service of servicesToCheck) {
          const component = components.find((c) =>
            c.name.toUpperCase().includes(service.name)
          );

          if (
            component &&
            severityRank[component.status] > severityRank[worstStatus]
          ) {
            worstStatus = component.status;
            worstService = service.label;
          }
        }

        if (worstStatus !== "operational") {
          setTwilioDown(true);
          setTwilioStatusMsg(
            `${worstService}: ${statusMap[worstStatus] || "Service may be affected."
            }`
          );
        } else {
          setTwilioDown(false);
          setTwilioStatusMsg("");
        }
      } catch (error) {
        console.error("Failed to fetch Twilio status:", error);
        setTwilioDown(true);
        setTwilioStatusMsg("Unable to determine Twilio service status.");
      }
    };

    checkTwilioStatus();

    // Refresh every 10 minutes
    const interval = setInterval(checkTwilioStatus, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const communicationChatBoxHandler = () => {
    dispatch(communicationChatBoxOpen(!isCommunicationChatBoxOpen));
  };

  async function getProspectTenantList() {
    let pList = [];
    let tList = [];
    let eList = [];
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });
    await axios
      .get(
        process.env.REACT_APP_COMMUNICATION_NODE_API_URL +
        "prospect/get-prospect-tenant-list",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          setTypeaheadProspectTenantList(response.data.data);
          typeaheadProspectTenantListRef.current = response.data.data;
          //Filter prospect and tenants
          const conversationMap = new Map(); // To remove duplicates

          // AFTER — fixed
          response.data.data.forEach((item) => {
            if (item.type === "Employee") {
              // Employees are always added regardless of conversationMap
              // because they can share a conversation_id with a tenant/prospect
              eList.push(item);
            } else {
              // For prospect/tenant/property — deduplicate by conversation_id as before
              if (!conversationMap.has(item.conversation_id)) {
                conversationMap.set(item.conversation_id, true);
                if (item.type === "Prospect") {
                  pList.push(item);
                } else if (item.type === "Tenant") {
                  tList.push(item);
                }
              }
            }
          });

          // Group tList by property_id
          const groupedTList = tList.reduce((acc, curr) => {
            if (!acc[curr.property_id]) {
              acc[curr.property_id] = [];
            }
            acc[curr.property_id].push(curr);
            return acc;
          }, {});

          // Fetch property names
          const propertyNamesMap = new Map();
          response.data.data.forEach((item) => {
            if (!propertyNamesMap.has(item.property_id)) {
              propertyNamesMap.set(item.property_id, item.property_name);
            }
          });

          // Construct the final array with property name and tenant list
          const finalList = [];
          propertyNamesMap.forEach((propertyName, propertyId) => {
            finalList.push({
              propertyName: propertyName,
              property_id: propertyId,
              tenants: groupedTList[propertyId] || [],
            });
          });

          setProspectList(pList);
          setTenantList(finalList);
          // setEmployeeList(eList);

          // Calculate total unread message count for prospects and tenants
          // const prospectUnreadCount = pList.reduce(
          //   (acc, curr) => acc + curr.unread_no,
          //   0
          // );
          // const tenantUnreadCount = finalList.reduce(
          //   (acc, curr) =>
          //     acc + curr.tenants.reduce((a, c) => a + c.unread_no, 0),
          //   0
          // );

          // setUnreadMessagesCounter(prospectUnreadCount + tenantUnreadCount);
          // unreadMessagesCounterRef.current =
          //   prospectUnreadCount + tenantUnreadCount;

          const prospectUnreadCount = pList.reduce(
            (acc, curr) => acc + curr.unread_no,
            0
          );
          const tenantUnreadCount = finalList.reduce(
            (acc, curr) =>
              acc + curr.tenants.reduce((a, c) => a + c.unread_no, 0),
            0
          );
          // Only count employee-only rows to avoid double counting (tenant+employee already in tenantUnreadCount)
          const employeeOnlyUnreadCount = eList.reduce(
            (acc, curr) =>
              curr.prospect_id === 0 && curr.tenant_id === 0
                ? acc + curr.unread_no
                : acc,
            0
          );
          setUnreadMessagesCounter(
            prospectUnreadCount + tenantUnreadCount + employeeOnlyUnreadCount
          );
          unreadMessagesCounterRef.current =
            prospectUnreadCount + tenantUnreadCount + employeeOnlyUnreadCount;

          //Create unique prospectTenantList, all unique prospect and tenant will be merged together
          // const mergeProspectTenantList = [...pList, ...tList];
          const mergeProspectTenantList = [...pList, ...tList, ...eList];
          setProspectTenantList(mergeProspectTenantList);
          prospectTenantListRef.current = mergeProspectTenantList;

          //Filter unread Messages list , will show in unread_message tab. showing all the conversations
          // const filterUnreadMessages = mergeProspectTenantList.filter(
          //   (v) => v.unread_no
          // );
          const filterUnreadMessages = mergeProspectTenantList;

          setUnreadMessageList(filterUnreadMessages);
          unreadMessageListRef.current = filterUnreadMessages;
        }

        //set reload state false. this used to reload communication chat when new prospect is added or edited
        dispatch(communicationChatReload(false));
      })
      .catch((error) => {
        console.log("error", error);

        return false;
      });

    return true;
  }

  useEffect(() => {
    const broadcastMessageHandlerForProspect = async (msg) => {
      try {
        let message = msg.data;

        // const userProperties = userInformation.current.properties;
        // console.log(userProperties);
        // if (!userInformation.current || !userInformation.current?.properties) {
        //     return;
        // }
        // const checkUserPermission = await userInformation.current.properties.find(
        //     (p) => p.id === message.propertyId
        // );
        // console.log(checkUserPermission);

        //When we get the new message update chatMessages if chat message is open otherwise update conversation-list, counter and unread message list

        if (
          prospectTenantDetailsRef.current &&
          prospectTenantDetailsRef.current.conversation_id === message.cid
        ) {
          chatMessagesListRef.current = [
            ...chatMessagesListRef.current,
            message,
          ];
          setChatMessagesList([...chatMessagesListRef.current]);

          //Increment unread_no for prospectTenantNames, that is used in message details
          // prospectTenantNames = prospectTenantNames.map((ptn) =>{
          //   ptn.unread_no = ptn.unread_no + 1
          //   return ptn;
          // })
          // setProspectTenantNames([...prospectTenantNames])

          //When get new message, need to increment unread_no for messageDetails object
          //     const incrementunReadNo = prospectTenantDetailsRef.current
          //     incrementunReadNo.unread_no =  incrementunReadNo.unread_no + 1;

          // prospectTenantDetailsRef.current = {...incrementunReadNo};
          // setProspectTenantDetails({...incrementunReadNo});
        }

        //Update message counter
        const updateMessageCounter = unreadMessagesCounterRef.current + 1;
        unreadMessagesCounterRef.current = updateMessageCounter;
        setUnreadMessagesCounter(updateMessageCounter);

        //Update conversation list
        const updateConversationList = conversationListRef.current.map((c) => {
          if (message.cid === c.conversationId) {
            c.messages = [...c.messages, message];
          }
          return c;
        });
        setConversationList(updateConversationList);
        conversationListRef.current = updateConversationList;

        //Update unread message list
        const isExist = unreadMessageListRef.current.find(
          (um) => um.conversation_id === message.cid
        );

        if (isExist) {
          const updateList = unreadMessageListRef.current.map((um) => {
            if (message.cid === um.conversation_id) {
              um.unread_no = um.unread_no + 1;
              um.message = message.message;
              um.message_time = new Date().toISOString();
            }
            return um;
          });

          unreadMessageListRef.current = updateList;
          setUnreadMessageList(updateList);
        } else {
          const findPropectTenant = prospectTenantListRef.current.find(
            (pt) => pt.conversation_id === message.cid
          );

          if (findPropectTenant) {
            findPropectTenant.unread_no = 1;
            findPropectTenant.message = message.message;
            findPropectTenant.message_time = new Date().toISOString();
            unreadMessageListRef.current = [
              findPropectTenant,
              ...unreadMessageListRef.current,
            ];

            setUnreadMessageList([...unreadMessageListRef.current]);
          } else {
            getProspectTenantList();
            //create prospect strcture and add it
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const broadcastMessageHandlerForTenant = async (msg) => {
      try {
        let message = msg.data;
        // const userProperties = userInformation.current.properties;
        // console.log(userProperties);
        // if (!userInformation.current || !userInformation.current?.properties) {
        //     return;
        // }
        // const checkUserPermission = await userInformation.current.properties.find(
        //     (p) => p.id === message.propertyId
        // );
        // console.log(checkUserPermission);

        //When we get the new message update chatMessages if chat message is open otherwise update conversation-list, counter and unread message list

        if (
          prospectTenantDetailsRef.current &&
          prospectTenantDetailsRef.current.conversation_id === message.cid
        ) {
          chatMessagesListRef.current = [
            ...chatMessagesListRef.current,
            message,
          ];
          setChatMessagesList([...chatMessagesListRef.current]);

          //When get new message, need to increment unread_no for messageDetails object
          //const incrementunReadNo = prospectTenantDetailsRef.current
          //     incrementunReadNo.unread_no =  incrementunReadNo.unread_no + 1;

          // prospectTenantDetailsRef.current = {...incrementunReadNo};
          // setProspectTenantDetails({...incrementunReadNo});
        }
        //Update message counter
        const updateMessageCounter = unreadMessagesCounterRef.current + 1;
        unreadMessagesCounterRef.current = updateMessageCounter;
        setUnreadMessagesCounter(updateMessageCounter);

        //Update conversation list
        const updateConversationList = conversationListRef.current.map((c) => {
          if (message.cid === c.conversationId) {
            c.messages = [...c.messages, message];
          }
          return c;
        });
        setConversationList(updateConversationList);
        conversationListRef.current = updateConversationList;

        //Update unread message list
        const isExist = unreadMessageListRef.current.find(
          (um) => um.conversation_id === message.cid
        );

        if (isExist) {
          const updateList = unreadMessageListRef.current.map((um) => {
            if (message.cid === um.conversation_id) {
              um.unread_no = um.unread_no + 1;
              um.message = message.message;
              um.message_time = new Date().toISOString();
            }
            return um;
          });

          unreadMessageListRef.current = updateList;
          setUnreadMessageList(updateList);
        } else {
          const findPropectTenant = prospectTenantListRef.current.find(
            (pt) => pt.conversation_id === message.cid
          );

          if (findPropectTenant) {
            findPropectTenant.unread_no = 1;
            findPropectTenant.message = message.message;
            findPropectTenant.message_time = new Date().toISOString();
            unreadMessageListRef.current = [
              findPropectTenant,
              ...unreadMessageListRef.current,
            ];
            setUnreadMessageList([...unreadMessageListRef.current]);
          } else {
            getProspectTenantList();
            //create prospect strcture and add it
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const getConversationHandlerForProspect = (messages) => {
      messageLoaderRef.current = false;
      setMessageLoader(false);
      setChatMessagesList(messages.data);
      chatMessagesListRef.current = messages.data;
      if (messages.data.length) {
        const conversation = {
          conversationId: messages.data[0].cid,
          messages: messages.data,
        };
        conversationList.push(conversation);
        setConversationList(conversationList);
        conversationListRef.current = conversationList;
      }

      // chatMessagesRef.current = messages.data;
    };
    const getConversationHandlerForTenant = (messages) => {
      messageLoaderRef.current = false;
      setMessageLoader(false);
      setChatMessagesList(messages.data);
      chatMessagesListRef.current = messages.data;
      if (messages.data.length) {
        const conversation = {
          conversationId: messages.data[0].cid,
          messages: messages.data,
        };
        conversationList.push(conversation);
        setConversationList(conversationList);
        conversationListRef.current = conversationList;
      }
    };

    if (socket) {
      socket.on(
        "broadcast-message-for-prospect",
        broadcastMessageHandlerForProspect
      );
      socket.on(
        "get-conversation-for-prospect",
        getConversationHandlerForProspect
      );
      socket.on(
        "broadcast-message-for-tenant",
        broadcastMessageHandlerForTenant
      );

      socket.on("get-conversation-for-tenant", getConversationHandlerForTenant);
    }
  }, [socket]);

  useEffect(() => {
    if (prospectTenantNames.length > 1) {
      const names = prospectTenantNames
        .splice(1)
        .map((tenant) => `${tenant.first_name} ${tenant.last_name}`)
        .join(", ");
      setProspectTenantNamesForToolTip(names);
    }
  }, prospectTenantNames);

  const initializeIdentityChatClient = async (identity) => {
    const initId = ++identityClientInitCount;

    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      const response = await axios.post(
        process.env.REACT_APP_COMMUNICATION_NODE_API_URL +
        "identity-chat/generate-token",
        { identity: String(identity) },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const twilioToken = response?.data?.data?.token;
      if (!twilioToken) {
        return;
      }

      const client = await ConversationsClient.create(twilioToken);

      identityClientRef.current = client;
      setIdentityClient(client);
      // setIdentityClientReady(true);

      const markReady = (source) => {
        setIdentityClientReady(true);
      };

      // Covers the case where initialization already completed before we attached listeners
      if (client.connectionState === "connected") {
        markReady("immediate-check");
      }

      client.on("connectionStateChanged", (state) => {
        if (state === "connected") markReady("connectionStateChanged");
      });
      client.on("stateChanged", (state) => {
        if (state === "initialized") markReady("stateChanged");
        if (state === "failed" || state === "denied") {
        }
      });

      client.on("connectionError", (err) => {
        console.log(`[INIT #${initId}] connectionError`, err);
      });

      client.on("tokenAboutToExpire", async () => {
        const refreshedAuth0Token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        });
        const refreshed = await axios.post(
          process.env.REACT_APP_COMMUNICATION_NODE_API_URL +
          "identity-chat/generate-token",
          { identity: String(identity) },
          { headers: { Authorization: `Bearer ${refreshedAuth0Token}` } }
        );
        const newToken = refreshed?.data?.data?.token;
        if (newToken) client.updateToken(newToken);
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (isAuthenticated && userInfo?.id) {
      initializeIdentityChatClient(userInfo.id);
    }
  }, [isAuthenticated, userInfo]);

  // AFTER — no network calls, no await needed
  const mapMessageMedia = (m) => {
    if (!m.media) return [];
    const mediaArray = Array.isArray(m.media) ? m.media : [m.media];
    return mediaArray.map((mediaItem) => ({
      content_type: mediaItem.contentType, // available instantly, no fetch
      url: null, // resolved lazily by the viewer
      _media: mediaItem, // keep the raw object for getContentTemporaryUrl() later
    }));
  };

  // load history + subscribe to new messages whenever the open conversation changes
  const parseReactions = (attributes) => {
    try {
      return attributes?.reactions || {};
    } catch (e) {
      return {};
    }
  };
  useEffect(() => {
    console.log(
      "[EFFECT] activeIdentityConversation dependency fired",
      activeIdentityConversation?.sid,
      activeIdentityConversation
    );
    let isCancelled = false;

    const loadMessages = async () => {
      if (!activeIdentityConversation) return;
      setIdentityMessageLoader(true);
      loadedMessageSidsRef.current = new Set(); // reset for the new conversation
      try {
        const paginator = await activeIdentityConversation.getMessages(20); // was: getMessages()
        console.log("paginator", paginator);
        messagesPaginatorRef.current = paginator;
        setHasMoreOlderMessages(!!paginator.hasPrevPage);

        const mapped = paginator.items.map((m) => {
          loadedMessageSidsRef.current.add(m.sid);
          return {
            sid: m.sid,
            author: m.author,
            message: m.body,
            createdAt: m.dateCreated,
            updatedAt: m.dateUpdated,
            reactions: parseReactions(m.attributes),
            media: mapMessageMedia(m), // now sync, see step below
            _message: m,
          };
        });
        if (!isCancelled) setIdentityChatMessagesList(mapped);
      } catch (error) {
        handleIdentityChatError(error, "loadMessages");
      } finally {
        if (!isCancelled) setIdentityMessageLoader(false);
      }
    };
    setTypingIdentities([]);
    loadMessages();

    const handleMessageAdded = (message) => {
      if (loadedMessageSidsRef.current.has(message.sid)) return; // guard against dupes
      loadedMessageSidsRef.current.add(message.sid);

      setTypingIdentities((prev) => prev.filter((id) => id !== message.author));
      const media = mapMessageMedia(message); // was: await mapMessageMedia(message)
      setIdentityChatMessagesList((prev) => [
        ...prev,
        {
          sid: message.sid,
          author: message.author,
          message: message.body,
          createdAt: message.dateCreated,
          updatedAt: message.dateUpdated,
          reactions: parseReactions(message.attributes),
          media,
          _message: message,
        },
      ]);
    };

    const handleMessageUpdated = ({ message, updateReasons }) => {
      setIdentityChatMessagesList((prev) =>
        prev.map((m) => {
          if (m.sid !== message.sid) return m;
          const updated = { ...m, _message: message };
          if (updateReasons.includes("body")) {
            updated.message = message.body;
            updated.updatedAt = message.dateUpdated;
          }
          if (updateReasons.includes("attributes")) {
            updated.reactions = parseReactions(message.attributes);
          }
          return updated;
        })
      );
    };

    const refreshPartnerMembers = async () => {
      if (!activeIdentityConversation) return;
      const isGroup = activeIdentityConversation.uniqueName?.startsWith("grp_");
      if (!isGroup) return;
      try {
        const participants = await activeIdentityConversation.getParticipants();
        const memberNames = participants
          .map((p) => {
            if (String(p.identity) === String(userInfo?.id)) return "You";
            const dir = employeeDirectory.find(
              (e) => String(e.id) === String(p.identity)
            );
            return dir ? dir.name : p.identity;
          })
          .join(", ");
        setActiveIdentityChatPartner((prev) =>
          prev ? { ...prev, members: memberNames } : prev
        );
      } catch (error) {
        handleIdentityChatError(error, "refreshPartnerMembers");
      }
    };
    const handleTypingStarted = (participant) => {
      setTypingIdentities((prev) => {
        if (prev.includes(participant.identity)) return prev;
        return [...prev, participant.identity];
      });
    };

    const handleTypingEnded = (participant) => {
      setTypingIdentities((prev) =>
        prev.filter((id) => id !== participant.identity)
      );
    };

    const handleParticipantJoined = () => refreshPartnerMembers();
    const handleParticipantLeft = () => refreshPartnerMembers();

    if (activeIdentityConversation) {
      activeIdentityConversation.on("messageAdded", handleMessageAdded);
      activeIdentityConversation.on("messageUpdated", handleMessageUpdated);
      activeIdentityConversation.on(
        "participantJoined",
        handleParticipantJoined
      );
      activeIdentityConversation.on("participantLeft", handleParticipantLeft);
      activeIdentityConversation.on("typingStarted", handleTypingStarted);
      activeIdentityConversation.on("typingEnded", handleTypingEnded);
    }

    return () => {
      isCancelled = true;
      if (activeIdentityConversation) {
        activeIdentityConversation.off("messageAdded", handleMessageAdded);
        activeIdentityConversation.off("messageUpdated", handleMessageUpdated);
        activeIdentityConversation.off(
          "participantJoined",
          handleParticipantJoined
        );
        activeIdentityConversation.off(
          "participantLeft",
          handleParticipantLeft
        );
        activeIdentityConversation.off("typingStarted", handleTypingStarted);
        activeIdentityConversation.off("typingEnded", handleTypingEnded);
      }
    };
  }, [activeIdentityConversation]);

  useEffect(() => {
    if (!identityClientReady || !identityClientRef.current) return;

    const client = identityClientRef.current;
    let debounceTimer = null;

    const scheduleRefresh = (reason) => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        refreshGroupsAndConversations();
      }, 500); // batches rapid-fire events into one refresh
    };

    const handleConversationUpdated = ({ conversation, updateReasons }) => {
      if (
        updateReasons.includes("lastMessage") ||
        updateReasons.includes("lastReadMessageIndex")
      ) {
        scheduleRefresh(`conversationUpdated:${conversation.uniqueName}`);
      }
    };

    const handleConversationJoined = (conversation) => {
      scheduleRefresh(`conversationJoined:${conversation.uniqueName}`);
    };

    const handleConversationLeft = (conversation) => {
      scheduleRefresh(`conversationLeft:${conversation.uniqueName}`);
    };

    client.on("conversationUpdated", handleConversationUpdated);
    client.on("conversationJoined", handleConversationJoined);
    client.on("conversationLeft", handleConversationLeft);

    return () => {
      client.off("conversationUpdated", handleConversationUpdated);
      client.off("conversationJoined", handleConversationJoined);
      client.off("conversationLeft", handleConversationLeft);
      if (debounceTimer) clearTimeout(debounceTimer);
    };
  }, [identityClientReady]);

  const getFallbackAvatar = (emp) => {
    if (emp.user_image_url) {
      return emp.user_image_url;
    }
    return emp.picture || null;
  };

  async function getEmployeeDirectory() {
    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      const response = await axios.get(
        process.env.REACT_APP_USER_API_URL + "v1/user-list",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const rawList = response?.data?.data || response?.data || [];

      // Unfiltered — used ONLY for resolving names on old messages, so a
      // deactivated/deleted employee's past messages still show their
      // real name instead of a raw ID. Never used for any list/UI that
      // implies current membership or availability.
      setAllEmployeesForNames(
        rawList.map((u) => ({
          id: u.id,
          first_name: u.first_name,
          last_name: u.last_name,
        }))
      );

      const filtered = rawList.filter(
        (u) =>
          u.is_archived !== 1 &&
          u.is_deleted !== 1 &&
          String(u.id) !== String(userInfo?.id)
      );

      const mapped = filtered.map((u) => ({
        id: u.id,
        name: u.name || `${u.first_name} ${u.last_name}`,
        role: u.role,
        job_title: u.job_title,
        first_name: u.first_name,
        last_name: u.last_name,
        phone: u.phone,
        property: Array.isArray(u.property_arr)
          ? pickDisplayProperty(u.property_arr)
          : u.property_name,
        avatar: getFallbackAvatar(u),
        online: u.is_online === 1,
        notiCount: 0,
      }));

      setEmployeeDirectory(mapped);
    } catch (error) {
      console.log("getEmployeeDirectory error", error);
    }
  }

  const pickDisplayProperty = (propertyArr) => {
    if (!Array.isArray(propertyArr) || propertyArr.length === 0) return "";
    const westonHall = propertyArr.find(
      (p) => p.toLowerCase() === "weston hall"
    );
    return westonHall || propertyArr[0];
  };

  useEffect(() => {
    if (isAuthenticated && userInfo?.id) {
      getEmployeeDirectory();
    }
  }, [isAuthenticated, userInfo]);

  // Build the Group Conversations list from subscribed Twilio conversations
  async function loadGroupConversations() {
    if (!identityClientRef.current) return;
    try {
      const paginator = await identityClientRef.current.getSubscribedConversations();
      const conversations = paginator.items || [];
      const groupConvos = conversations.filter(
        (c) => c.uniqueName && c.uniqueName.startsWith("grp_")
      );

      const mapped = await Promise.all(
        groupConvos.map(async (convo) => {
          const participants = await convo.getParticipants();
          const memberIds = participants.map((p) => p.identity);

          const memberNames = memberIds
            .map((id) => {
              if (String(id) === String(userInfo?.id)) return "You";
              const dir = employeeDirectory.find(
                (e) => String(e.id) === String(id)
              );
              return dir ? dir.name : null; // was: id — drop deactivated/deleted members from the visible list
            })
            .filter(Boolean)
            .join(", ");

          return {
            id: convo.sid,
            uniqueName: convo.uniqueName,
            name: convo.friendlyName || convo.uniqueName,
            members: memberNames,
            memberIds, // new — needed for edit prefill
            avatars: [],
            notiCount: 0,
            _conversation: convo,
          };
        })
      );

      setGroupList(mapped);
    } catch (error) {
      console.log("loadGroupConversations error", error);
    }
  }

  useEffect(() => {
    if (identityClientReady) {
      loadGroupConversations();
    }
  }, [identityClientReady, employeeDirectory]);

  async function loadEmployeeGroupsUnreadList() {
    if (!identityClientRef.current) return;
    try {
      const paginator = await identityClientRef.current.getSubscribedConversations();
      const conversations = paginator.items || [];

      const relevant = conversations.filter(
        (c) =>
          c.uniqueName &&
          (c.uniqueName.startsWith("grp_") || c.uniqueName.startsWith("dm_")) &&
          !c.uniqueName.includes("undefined")
      );

      const mapped = await Promise.all(
        relevant.map(async (convo) => {
          const isGroup = convo.uniqueName.startsWith("grp_");

          let lastMsg = null;
          try {
            const lastMsgPage = await convo.getMessages(1);
            lastMsg = lastMsgPage.items[0] || null;
          } catch (e) {
            console.log(
              "[LOAD LIST] getMessages threw for",
              convo.uniqueName,
              e
            );
            lastMsg = null;
          }

          if (!isGroup && !lastMsg) {
            console.log(
              "[LOAD LIST] EXCLUDED (no message) DM:",
              convo.uniqueName
            );
            return null;
          }

          let unreadCount = 0;
          try {
            unreadCount = (await convo.getUnreadMessagesCount()) || 0;
          } catch (e) {
            console.log(
              "[LOAD LIST] getUnreadMessagesCount threw for",
              convo.uniqueName,
              e
            );
            unreadCount = 0;
          }

          let participants = [];
          try {
            participants = await convo.getParticipants();
          } catch (e) {
            console.log(
              "[LOAD LIST] getParticipants threw for",
              convo.uniqueName,
              e
            );
          }

          let name = convo.friendlyName || convo.uniqueName;
          let employeeRef = null;
          let avatars = [];
          let subtitle = "";

          if (!isGroup) {
            const otherId = participants
              .map((p) => p.identity)
              .find((id) => String(id) !== String(userInfo?.id));

            const dir = employeeDirectory.find(
              (e) => String(e.id) === String(otherId)
            );

            // Employee no longer exists in PropertyDek (deleted here but
            // the Twilio conversation still exists) — hide it rather
            // than show a raw identity number, matching mobile's
            // existing behavior.
            if (!dir) return null;

            name = dir.name;
            employeeRef = dir;
            subtitle = dir.job_title || "";
          } else {
            const memberNames = participants
              .map((p) => {
                if (String(p.identity) === String(userInfo?.id)) return "You";
                const dir = employeeDirectory.find(
                  (e) => String(e.id) === String(p.identity)
                );
                return dir ? dir.name : null;
              })
              .filter(Boolean);
            subtitle = memberNames.join(", ");

            avatars = participants
              .map((p) => {
                const dir = employeeDirectory.find(
                  (e) => String(e.id) === String(p.identity)
                );
                if (!dir) return null; // no matching directory entry — genuinely skip
                return { avatar: dir.avatar || null, name: dir.name };
              })
              .filter(Boolean);
          }

          const result = {
            id: convo.sid,
            type: isGroup ? "Group" : "Employee",
            name,
            subtitle,
            unreadCount,
            avatars,
            lastMessageTime: lastMsg?.dateCreated || null,
            _conversation: convo,
            _employee: employeeRef,
          };

          return result;
        })
      );

      const filtered = mapped.filter(Boolean);

      filtered.sort((a, b) => {
        const ta = a.lastMessageTime
          ? new Date(a.lastMessageTime).getTime()
          : 0;
        const tb = b.lastMessageTime
          ? new Date(b.lastMessageTime).getTime()
          : 0;
        return tb - ta;
      });

      // Fill in every employee who doesn't already have a real DM entry above
      // (never messaged, or messaged but zero-message DM — both treated the same)
      const representedEmployeeIds = new Set(
        filtered
          .filter((i) => i.type === "Employee")
          .map((i) => String(i._employee?.id))
      );

      const remainingEmployees = employeeDirectory.filter(
        (emp) => !representedEmployeeIds.has(String(emp.id))
      );

      const placeholders = remainingEmployees
        .map((emp) => ({
          id: `placeholder_${emp.id}`,
          type: "Employee",
          name: emp.name,
          subtitle: emp.job_title,
          unreadCount: 0,
          avatars: [],
          lastMessageTime: null,
          _conversation: null,
          _employee: emp,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));

      const combined = [...filtered, ...placeholders];

      setEmployeeGroupsUnreadList(combined);
      setEmployeeGroupsTotalUnread(
        combined.reduce((acc, i) => acc + i.unreadCount, 0)
      );
    } catch (error) {
      handleIdentityChatError(error, "loadEmployeeGroupsUnreadList");
    }
  }

  useEffect(() => {
    if (identityClientReady) {
      loadEmployeeGroupsUnreadList();
    }
  }, [identityClientReady, employeeDirectory]);

  useEffect(() => {
    if (
      isAuthenticated &&
      userInfo?.id &&
      !hasInitializedIdentityVoiceRef.current
    ) {
      hasInitializedIdentityVoiceRef.current = true;

      initializeIdentityVoiceDevice({
        userId: userInfo.id,
        getAccessTokenSilently,
        onDeviceReady: (device) => {
          identityVoiceDeviceRef.current = device;
          setIdentityVoiceDevice(device);
        },
        onIncomingCall: (call) => {
          setIncomingIdentityCall(call);

          const clearIfCancelled = () => {
            setIncomingIdentityCall(null);
          };

          call.on("cancel", clearIfCancelled);
          call.on("disconnect", clearIfCancelled);
          call.on("reject", clearIfCancelled);
        },
        onDeviceError: (error) => {
          console.log("[IDENTITY VOICE] device error in component", error);
          // setSnackbarOpen(true);
          // setSnackbarMsg(
          //   "Voice calling encountered an error. You may need to refresh the page."
          // );
        },
      });
    }
  }, [isAuthenticated, userInfo?.id]);

  useEffect(() => {
    const handleVisibilityOrFocus = () => {
      if (
        document.visibilityState === "visible" &&
        identityVoiceDeviceRef.current
      ) {
        // Covers: tab was backgrounded, laptop slept, or the browser
        // throttled/dropped the signaling connection during a long idle
        // period — re-register proactively instead of waiting to see if
        // the SDK's own reconnect attempt errors out first.
        identityVoiceDeviceRef.current.register().catch((err) => {
          console.log("[IDENTITY VOICE] re-register on tab focus failed", err);
        });
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityOrFocus);
    window.addEventListener("focus", handleVisibilityOrFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityOrFocus);
      window.removeEventListener("focus", handleVisibilityOrFocus);
    };
  }, []);

  const assignedTenantConversations = useMemo(() => {
    const requestConvos = userInfo?.request_conversations || [];
    return requestConvos
      .map((rc) => {
        const match = typeaheadProspectTenantList.find(
          (pt) =>
            pt.conversation_id === rc.conversation_id && pt.type === "Tenant"
        );
        return match
          ? {
            ...match,
            request_id: rc.request_id,
            request_no: rc.request_no,
            title: rc.title,
          }
          : null;
      })
      .filter(Boolean);
  }, [userInfo?.request_conversations, typeaheadProspectTenantList]);

  const assignedTenantUnreadCount = useMemo(
    () =>
      assignedTenantConversations.reduce(
        (acc, item) => acc + (item.unread_no || 0),
        0
      ),
    [assignedTenantConversations]
  );
  const tabHandler = (value) => {
    if (value === "globalListTab") {
      setIsShowGlobalList(true);
      setIsShowUnreadMessageList(false);
      setIsShowTeamTab(false);
    } else if (value === "unreadMessageTab") {
      setIsShowGlobalList(false);
      setIsShowUnreadMessageList(true);
      setIsShowTeamTab(false);
    } else if (value === "teamTab") {
      setIsShowGlobalList(false);
      setIsShowUnreadMessageList(false);
      setIsShowTeamTab(true);
    }
  };

  useEffect(() => {
    if (
      isAuthenticated &&
      user["https://propertydek.com/permissions"].indexOf(
        "smschat-tenant:read"
      ) > -1
    ) {
      setIsShowGlobalList(true);
      setIsShowUnreadMessageList(false);
      setIsShowTeamTab(false);
    } else if (
      isAuthenticated &&
      user["https://propertydek.com/permissions"].indexOf("smschat-team:read") >
      -1
    ) {
      setIsShowGlobalList(false);
      setIsShowUnreadMessageList(false);
      setIsShowTeamTab(true);
    }
  }, [user, isAuthenticated]);

  const toggleMessageReaction = async (msg, emoji) => {
    try {
      // Re-fetch the live message right before writing, to minimize the
      // read-modify-write race if someone else reacted a moment ago
      const freshMessage = await msg._message.conversation
        .getMessages()
        .then(
          (page) => page.items.find((m) => m.sid === msg.sid) || msg._message
        );

      const currentAttrs = freshMessage.attributes || {};
      const reactions = { ...(currentAttrs.reactions || {}) };
      const myId = String(userInfo.id);

      // Remove myself from whichever emoji I previously had, if any
      Object.keys(reactions).forEach((key) => {
        reactions[key] = (reactions[key] || []).filter((id) => id !== myId);
        if (reactions[key].length === 0) delete reactions[key];
      });

      // If I clicked the same emoji I already had, this is a toggle-off — done.
      // Otherwise, add myself to the new one.
      const alreadyHadThisEmoji = (
        currentAttrs.reactions?.[emoji] || []
      ).includes(myId);
      if (!alreadyHadThisEmoji) {
        reactions[emoji] = [...(reactions[emoji] || []), myId];
      }

      await freshMessage.updateAttributes({ ...currentAttrs, reactions });

      setIdentityChatMessagesList((prev) =>
        prev.map((m) =>
          m.sid === msg.sid ? { ...m, reactions, _message: freshMessage } : m
        )
      );
    } catch (error) {
      handleIdentityChatError(error, "toggleMessageReaction");
    }
  };

  // Opens or creates a 1:1 identity conversation

  const setDetailsForIdentityChat = async (employee) => {
    if (!identityClientRef.current || !userInfo?.id) return;
    if (isOpeningIdentityChat) return; // ignore double-clicks while one is in flight

    setIsOpeningIdentityChat(true);

    try {
      const ids = [String(userInfo.id), String(employee.id)].sort(
        (a, b) => Number(a) - Number(b)
      );
      const uniqueName = `dm_${ids[0]}_${ids[1]}`;

      let conversation;
      try {
        conversation = await identityClientRef.current.getConversationByUniqueName(
          uniqueName
        );

        console.log(
          "[SET-CONVO] via setDetailsForIdentityChat",
          conversation?.sid
        );
      } catch (lookupError) {
        // 50350 = conversation not found — the only case where creating is correct
        if (lookupError.code && lookupError.code !== 50350) {
          console.log("Unexpected lookup error", lookupError);
          return;
        }

        try {
          conversation = await identityClientRef.current.createConversation({
            uniqueName,
          });
          await conversation.add(String(userInfo.id));
          await conversation.add(String(employee.id));
        } catch (createError) {
          console.log(
            "createConversation error",
            createError.code,
            createError
          );

          // The conversation may already exist (created moments ago, or by
          // another path) even though our earlier lookup didn't find it yet.
          // Try fetching it directly before giving up.
          try {
            conversation = await identityClientRef.current.getConversationByUniqueName(
              uniqueName
            );
          } catch (secondLookupError) {
            console.log("Second lookup also failed", secondLookupError);
            handleIdentityChatError(
              createError,
              "setDetailsForIdentityChat:create"
            );
            return;
          }
        }
      }

      setActiveIdentityConversation(conversation);
      // setActiveIdentityChatPartner(employee); // needed for the header, see step 3
      setIsShowIdentityChatMessages(true);
      await conversation.setAllMessagesRead();
      refreshGroupsAndConversations();
    } catch (error) {
      console.log("setDetailsForIdentityChat error", error);
    } finally {
      setIsOpeningIdentityChat(false);
    }
  };

  // Opens an existing group conversation (creation happens via Add Group modal, next step)
  const setDetailsForGroup = async (group) => {
    console.log("[SET-CONVO] via setDetailsForGroup", group._conversation?.sid);
    setActiveIdentityConversation(group._conversation);
    setActiveIdentityChatPartner({
      conversation_id: group.id,
      name: group.name,
      property: "Weston Hall Staff",
      members: group.members,
      type: "Group",
    });
    setIsShowIdentityChatMessages(true);

    try {
      await group._conversation.setAllMessagesRead();
      refreshGroupsAndConversations();
    } catch (e) {
      console.log("setAllMessagesRead failed", e);
    }
  };
  const setDetails = (value) => {
    try {
      const savedDraft = localStorage.getItem(`draft_${value.conversation_id}`);
      setMessageTextVal(savedDraft || "");
      setChatMessagesList([]);
      chatMessagesListRef.current = [];
      setProspectTenantDetails(value);
      prospectTenantDetailsRef.current = value;
      setMessageLoader(true);
      messageLoaderRef.current = true;
      setIsShowChatMessages(true);
      const payload = { conversationId: value.conversation_id };
      const isconversationExist = conversationList.find(
        (c) => c.conversationId === value.conversation_id
      );
      // If opened from Employee section, show only employee entry
      // Otherwise show all matching entries (prospect/tenant with multiple people in same apt)
      const findPropectTenantName =
        value.type === "Employee"
          ? typeaheadProspectTenantList.filter(
            (pt) =>
              value.conversation_id === pt.conversation_id &&
              pt.type === "Employee" &&
              pt.id === value.id
          )
          : typeaheadProspectTenantList.filter(
            (pt) =>
              value.conversation_id === pt.conversation_id &&
              pt.type !== "Employee"
          );
      setProspectTenantNames(findPropectTenantName);
      // if (!isconversationExist) {
      if (true) {
        if (value.type === "Prospect") {
          socket.emit("/request-conversation-for-prospect", payload);
        } else {
          socket.emit("/request-conversation-for-tenant", payload);
        }
      } else {
        setMessageLoader(false);

        setChatMessagesList(isconversationExist.messages);
        chatMessagesListRef.current = isconversationExist.messages;
      }

      dispatch(resetConversationId());

      //Find unread message from the selected conversation and reset to 0
      //we will subtract unread counter of particular conversation from unreadMessageList
      // const findUnreadCounter = unreadMessageList.find(
      //   (um) => um.conversation_id === value.conversation_id
      // );
      // console.log("findUnreadCounter", findUnreadCounter);

      // if (findUnreadCounter) {
      // const updateCounter =
      //   unreadMessagesCounter - findUnreadCounter.unread_no;
      // setUnreadMessagesCounter(updateCounter);
      // unreadMessagesCounterRef.current = updateCounter;

      //update unread_message_list, conversation removed from message list
      // const filterList = unreadMessageList.filter(
      //   (um) => um.conversation_id !== value.conversation_id
      // );
      // setUnreadMessageList(filterList);
      // unreadMessageListRef.current = filterList;

      //update unread_no on server set to zero
      // socket.emit("read-message-for-prospect", {
      //   conversationId: value.conversation_id,
      // });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectAssignedTenantConversation = (item) => {
    setIsRequestBasedAccess(true);
    setDetails(item);
  };

  const setDetailsForEmployee = (employee) => {
    // Reuse existing setDetails logic — same conversation_id based approach
    setDetails(employee);
  };

  const setDetailsForPropertiesChat = (value) => {
    console.log("vaalue", value);

    try {
      setMessageTextVal("");
      setChatMessagesList([]);
      chatMessagesListRef.current = [];
      setProspectTenantDetails(value);
      prospectTenantDetailsRef.current = value;
      setMessageLoader(true);
      messageLoaderRef.current = true;
      setIsShowChatMessages(true);
      setIsShowPropertyChatMessages(true);
      const payload = { conversationId: value.conversation_id };

      if (value.type === "Prospect") {
        socket.emit("/request-conversation-for-prospect", payload);
      } else {
        socket.emit("/request-conversation-for-tenant", payload);
      }

      dispatch(resetConversationId());

      //Find unread message from the selected conversation and reset to 0
      //we will subtract unread counter of particular conversation from unreadMessageList
      // const findUnreadCounter = unreadMessageList.find(
      //   (um) => um.conversation_id === value.conversation_id
      // );
      // console.log("findUnreadCounter", findUnreadCounter);

      // if (findUnreadCounter) {
      // const updateCounter =
      //   unreadMessagesCounter - findUnreadCounter.unread_no;
      // setUnreadMessagesCounter(updateCounter);
      // unreadMessagesCounterRef.current = updateCounter;

      //update unread_message_list, conversation removed from message list
      // const filterList = unreadMessageList.filter(
      //   (um) => um.conversation_id !== value.conversation_id
      // );
      // setUnreadMessageList(filterList);
      // unreadMessageListRef.current = filterList;

      //update unread_no on server set to zero
      // socket.emit("read-message-for-prospect", {
      //   conversationId: value.conversation_id,
      // });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGlobalEmployeeSelect = (emp) => {
    setActiveIdentityChatPartner({
      conversation_id: emp.id,
      name: emp.name,
      property: emp.property,
      job_title: emp.job_title,
      role: emp.role,
      job_title: emp.job_title,
      phone: emp.phone,
      first_name: emp.first_name,
      last_name: emp.last_name,
      type: "Employee",
      status: emp.online ? "Online" : "Offline",
    });
    setDetailsForIdentityChat(emp);
  };

  const handleEmployeeGroupsUnreadSelect = (item) => {
    if (item.type === "Group") {
      const found = groupList.find((g) => g.id === item.id);
      if (found) {
        setDetailsForGroup(found);
      } else {
        handleIdentityChatError(
          new Error("Group not found in groupList"),
          "handleEmployeeGroupsUnreadSelect"
        );
      }
    } else {
      setActiveIdentityChatPartner({
        conversation_id: item._employee.id,
        name: item._employee.name,
        property: item._employee.property,
        role: item._employee.role,
        job_title: item._employee.job_title,
        phone: item._employee.phone,
        first_name: item._employee.first_name,
        last_name: item._employee.last_name,
        type: "Employee",
        status: item._employee.online ? "Online" : "Offline",
      });
      setDetailsForIdentityChat(item._employee);
    }
  };

  const markAsReadConversationMessages = (conversationId) => {
    //Increment unread_no for prospectTenantNames, that is used in message details
    // let updateProspectTenantNames = prospectTenantNames.map((ptn) =>{
    //   ptn.unread_no = 0
    //   return ptn;
    // })
    // setProspectTenantNames([...updateProspectTenantNames])
    //Find unread message from the selected conversation and reset to 0
    //we will subtract unread counter of particular conversation from unreadMessageList
    const findUnreadCounter = unreadMessageList.find(
      (um) => um.conversation_id === conversationId
    );

    if (findUnreadCounter) {
      const updateCounter = unreadMessagesCounter - findUnreadCounter.unread_no;
      setUnreadMessagesCounter(updateCounter);
      unreadMessagesCounterRef.current = updateCounter;

      //Reset message counter to zero for selected conversation
      const filterList = unreadMessageList.map((um) => {
        if (um.conversation_id === conversationId) {
          um.unread_no = 0;
        }
        return um;
      });
      setUnreadMessageList(filterList);
      unreadMessageListRef.current = filterList;

      //update unread_no on server set to zero

      socket.emit("read-message-for-prospect", {
        conversationId: conversationId,
      });
    }
  };

  const toggleAccordionForProspect = () => {
    setaccordionOnForProspect(!accordionOnForProspect);
  };
  const toggleAccordionForProspectUnRead = () => {
    setaccordionOnForProspectUnRead(!accordionOnForProspectUnRead);
  };
  const toggleAccordionForTenantUnRead = () => {
    setaccordionOnForTenantUnRead(!accordionOnForTenantUnRead);
  };

  const toggleAccordionForTenant = (id) => {
    setSelectedProperty(id);
    if (selectedProperty === id) {
      setaccordionOnForTenant(!accordionOnForTenant);
    } else {
      setaccordionOnForTenant(true);
    }
  };

  const toggleAccordionForEmployee = () => setAccordionOnForEmployee((p) => !p);
  const toggleAccordionForEmployeeUnRead = () =>
    setAccordionOnForEmployeeUnRead((p) => !p);

  // const handleChange = (e) => {
  //   setMessageTextVal(e.target.value);
  // };

  const saveDraft = (value, conversationId) => {
    if (!conversationId) return;
    if (value) {
      localStorage.setItem(`draft_${conversationId}`, value);
    } else {
      localStorage.removeItem(`draft_${conversationId}`);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setMessageTextVal(value);
    saveDraft(value, prospectTenantDetails?.conversation_id);
  };

  const sendMessage = () => {
    try {
      console.log(user);
      const userId = user.sub;

      let currentVal = messageTextVal;
      currentVal = currentVal.trim();
      if (currentVal) {
        if (!prospectTenantDetails.conversation_id) {
          toast.error("No conversation found");
        }
        const outgoingMessage = isRequestBasedAccess
          ? `${userInfo?.job_title} - ${user?.given_name}: ${currentVal}`
          : currentVal;

        const messagePayload = {
          conversationId: prospectTenantDetails.conversation_id,
          senderId: userId,
          senderName: user?.given_name + " " + user?.family_name,
          message: outgoingMessage,
          type: messageType,
        };
        console.log("Sending message payload:", messagePayload);

        const currentDate = new Date();
        const isoDate = currentDate.toISOString();
        const messageItem = {
          cid: messagePayload.conversationId,
          author: messagePayload.senderName,
          createdAt: isoDate,
          message: outgoingMessage,
          senderId: userId,
          media: [],
        };

        setChatMessagesList([...chatMessagesList, messageItem]);
        chatMessagesListRef.current = [...chatMessagesList, messageItem];

        if (prospectTenantDetails.type === "Prospect") {
          socket.emit("send-message-for-prospect", messagePayload);
          setMessageType("propertydek-message");
        } else {
          socket.emit("send-message-for-tenant", messagePayload);
          setMessageType("propertydek-message");
        }
        localStorage.removeItem(
          `draft_${prospectTenantDetails?.conversation_id}`
        );
        setMessageTextVal("");
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendMessageForPropertiesChat = () => {
    try {
      const userId = user.sub;

      let currentVal = messageTextVal;
      currentVal = currentVal.trim();
      if (currentVal) {
        if (!prospectTenantDetails.conversation_id) {
          toast.error("No conversation found");
        }
        const messagePayload = {
          conversationId: prospectTenantDetails.conversation_id,
          senderId: userId,
          senderName: user.name,
          message: currentVal,
          type: messageType,
        };
        const currentDate = new Date();
        const isoDate = currentDate.toISOString();
        const messageItem = {
          cid: messagePayload.conversationId,
          author: messagePayload.senderName,
          createdAt: isoDate,
          message: currentVal,
          senderId: userId,
          media: [],
        };

        setChatMessagesList([...chatMessagesList, messageItem]);
        chatMessagesListRef.current = [...chatMessagesList, messageItem];

        onSendPropertyMessage(messagePayload);
        setMessageTextVal("");
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSendPropertyMessage = async (messagePayload) => {
    if (prospectTenantDetails.tenants.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMsg("This property has no tenants to send a message to!");
    }

    let message = messagePayload.message;
    if (!prospectTenantDetails?.property_id || !message) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please enter a message before sending!");
      return;
    }

    const data = {
      property_id: prospectTenantDetails?.property_id,
      message: messagePayload.message,
      senderName: messagePayload.senderName,
      senderId: messagePayload.senderId,
      messageType: messagePayload.type,
      conversation_id: messagePayload.conversationId,
    };

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    const SelectedPropertyId = prospectTenantDetails?.property_id;
    const selectedFloor = prospectTenantDetails?.floor;
    let url =
      process.env.REACT_APP_APPLICANT_API_URL +
      `v1/send-bulk-message/${SelectedPropertyId}`;

    if (selectedFloor) {
      url =
        process.env.REACT_APP_APPLICANT_API_URL +
        `v1/send-bulk-message/${SelectedPropertyId}?floor=${selectedFloor}`;
    }

    await axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSnackbarOpen(true);
        setSnackbarMsg(response?.data?.message);
      })
      .catch((error) => {
        setSnackbarOpen(true);
        setSnackbarMsg("Server error");
      });
  };

  // send + input handlers
  const handleIdentityChatChange = (e) => {
    setIdentityMessageTextVal(e.target.value);

    if (!activeIdentityConversation) return;
    const now = Date.now();
    if (now - lastTypingCallRef.current > 3000) {
      lastTypingCallRef.current = now;
      activeIdentityConversation.typing().catch((err) => {
        console.log("typing() call failed", err);
      });
    }
  };

  const sendIdentityChatMessage = async () => {
    if (!activeIdentityConversation) return;
    if (!identityMessageTextVal.trim() && !pendingAttachment) return;

    setIsUploadingAttachment(!!pendingAttachment);
    try {
      if (pendingAttachment) {
        const formData = new FormData();
        formData.append(
          "media",
          pendingAttachment.file,
          pendingAttachment.name
        );
        if (identityMessageTextVal.trim()) {
          formData.append("body", identityMessageTextVal.trim());
        }
        await activeIdentityConversation.sendMessage(formData);
        handleCancelAttachment();
      } else {
        await activeIdentityConversation.sendMessage(
          identityMessageTextVal.trim()
        );
      }
      setIdentityMessageTextVal("");
      await activeIdentityConversation.setAllMessagesRead();
      refreshGroupsAndConversations();
    } catch (error) {
      handleIdentityChatError(error, "sendIdentityChatMessage");
    } finally {
      setIsUploadingAttachment(false);
    }
  };

  const editIdentityChatMessage = async (msg, newBody) => {
    try {
      await msg._message.updateBody(newBody.trim());
      setIdentityChatMessagesList((prev) =>
        prev.map((m) =>
          m.sid === msg.sid
            ? {
              ...m,
              message: newBody.trim(),
              updatedAt: new Date().toISOString(),
            }
            : m
        )
      );
    } catch (error) {
      handleIdentityChatError(error, "editIdentityChatMessage");
    }
  };

  const resolveAuthorName = (identity) => {
    const found = allEmployeesForNames.find(
      (e) => String(e.id) === String(identity)
    );
    return found ? `${found.first_name} ${found.last_name}` : identity;
  };

  const resolveAuthorAvatar = (identity) => {
    const found = employeeDirectory.find(
      (e) => String(e.id) === String(identity)
    );
    return found ? found.avatar : "";
  };

  // const handlePromptClick = (promptText) => {
  //   setMessageType("propertydek-prompt");
  //   setMessageTextVal((prevText) => {
  //     if (!prevText) return promptText;
  //     return `${ prevText }\n${ promptText }`;
  //   });
  // };

  const handlePromptClick = (promptText) => {
    const firstName =
      prospectTenantNames?.length > 0
        ? prospectTenantNames
          .map((pt) => pt.first_name || "")
          .filter(Boolean)
          .join(" & ")
        : "";

    const resolvedText = promptText.replace(/{{firstName}}/g, firstName);

    setMessageTextVal((prevText) => {
      const newValue = !prevText
        ? resolvedText
        : `${prevText}\n${resolvedText}`;
      saveDraft(newValue, prospectTenantDetails?.conversation_id); // ← save draft here too
      return newValue;
    });
  };

  const backToList = () => {
    try {
      setIsShowChatMessages(false);
      setIsShowPropertyChatMessages(false);

      const updateConversationList = conversationList.map((c) => {
        if (c.conversationId === prospectTenantDetails.conversation_id) {
          c.messages = [...chatMessagesList];
        }
        return c;
      });
      setConversationList(updateConversationList);
      conversationListRef.current = updateConversationList;

      //update unread_no on server set to zero
      // socket.emit("read-message-for-prospect", {
      //   conversationId: prospectTenantDetails.conversation_id,
      // });

      //Add last conversation message to unread list tp update  local unreadMessage list

      if (chatMessagesList && chatMessagesList.length) {
        let msg = "";
        const lastMessage = chatMessagesList[chatMessagesList.length - 1];
        const time = lastMessage.createdAt;
        if (lastMessage.senderId) {
          msg = `You: ${lastMessage.message}`;

          const updateList = unreadMessageListRef.current.map((um) => {
            if (prospectTenantDetails.conversation_id === um.conversation_id) {
              um.message = msg;
              um.message_time = time;
            }
            return um;
          });

          unreadMessageListRef.current = updateList;
          setUnreadMessageList(updateList);
        }
      }

      //reset details informations
      setProspectTenantDetails(null);
      prospectTenantDetailsRef.current = null;
      setProspectTenantNames([]);
      setIsRequestBasedAccess(false);
    } catch (error) {
      console.log(error);
    }
  };

  const backToListFromIdentityChat = () => {
    console.log("[SET-CONVO] via backToListFromIdentityChat -> null");
    setIsShowIdentityChatMessages(false);
    setActiveIdentityConversation(null);
    setActiveIdentityChatPartner(null);
    setIdentityChatMessagesList([]);
    setHasMoreOlderMessages(false);
    setIsLoadingOlderMessages(false);
    messagesPaginatorRef.current = null;
    loadedMessageSidsRef.current = new Set();
  };

  const filterByCallback = (option, props) => {
    const inputValue = props.text.toLowerCase();
    const firstName = option.first_name ? option.first_name.toLowerCase() : "";
    const lastName = option.last_name ? option.last_name.toLowerCase() : "";
    const phone = option.phone ? option.phone.toLowerCase() : "";

    return (
      firstName.includes(inputValue) ||
      lastName.includes(inputValue) ||
      phone.includes(inputValue)
    );
  };

  const onSelectTypeahead = (value) => {
    value = value[0];

    // Match by both conversation_id AND type AND id
    // so Employee search result opens as Employee, not as the
    // Prospect that may share the same conversation_id
    const findTenantProspect = prospectTenantList.find(
      (pt) =>
        pt.conversation_id === value.conversation_id &&
        pt.type === value.type &&
        pt.id === value.id
    );

    if (findTenantProspect) {
      setDetails(findTenantProspect);
    } else {
      toast.error("Prospect or Tenant not found");
    }
  };

  const navigateTo = (v) => { };

  const initiateVoiceCall = (item) => {
    if (!item?.phone) {
      setSnackbarOpen(true);
      setSnackbarMsg("This employee doesn't have a phone number on file.");
      return;
    }
    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      setOpenCallModal(true);
      setProspectInfoObj(item);
    }
  };
  const initiateVoiceCallConfirm = async () => {
    setOpenCallModal(false);

    let initailTemp = "?";
    if (
      prospectInfoObj?.first_name !== "" &&
      prospectInfoObj?.last_name !== ""
    ) {
      initailTemp = prospectInfoObj?.first_name.charAt(0);
      initailTemp += prospectInfoObj?.last_name.charAt(0);
      initailTemp = initailTemp.toUpperCase();
    }

    let newProspectInfo = {
      id:
        prospectInfoObj?.type === "Tenant"
          ? prospectInfoObj?.tenant_id
          : prospectInfoObj?.id,
      full_name: prospectInfoObj?.first_name + " " + prospectInfoObj?.last_name,
      initial: initailTemp,
      phone: prospectInfoObj?.phone,
      user_avatar: "",
      type: prospectInfoObj?.type,
    };
    dispatch(communicationVoiceCallScreenOpen(true));
    dispatch(setVoiceCallInfo(newProspectInfo));
  };

  const initiateVoiceCallByDialPad = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }

    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      handleCallDialerClose();

      let newProspectInfo = {
        id: phoneNumber,
        full_name: "",
        initial: "?",
        phone: phoneNumber,
        user_avatar: "",
        type: "Manual",
      };
      dispatch(communicationVoiceCallScreenOpen(true));
      dispatch(setVoiceCallInfo(newProspectInfo));
    }
  };

  const initiateInAppVoiceCall = async (employee) => {
    const targetId = employee?.id ?? employee?.conversation_id;

    if (!targetId) {
      setSnackbarOpen(true);
      setSnackbarMsg("Unable to determine who to call.");
      return;
    }

    if (!identityVoiceDeviceRef.current) {
      // setSnackbarOpen(true);
      // setSnackbarMsg(
      //   "Voice calling isn't ready yet. Please try again in a moment."
      // );
      return;
    }
    try {
      const call = await identityVoiceDeviceRef.current.connect({
        params: {
          targetIdentity: String(targetId),
          isInAppVoiceCall: "true",
        },
      });
      setActiveIdentityCall(call);
      setActiveIdentityCallPartnerName(employee.name);
      setActiveIdentityCallPartnerIdentity(targetId);
      setActiveIdentityCallPartnerAvatar(employee?.avatar || "");
      activeIdentityCallPartnerIdentityRef.current = targetId;
      setIsOutgoingCall(true); // ADD THIS
    } catch (error) {
      handleIdentityChatError(error, "initiateInAppVoiceCall");
    }
  };

  const hanldePromptModal = (value) => {
    setIsPromptModalOpen(value);
    setIsShowPromptAddForm(false);
  };

  const hanldeCallForwardModal = (value) => {
    setIsCallForwardModalOpen(value);
  };

  const hanldePromptModalForConversation = (value) => {
    setIsPromptModalOpen(value);
    setIsShowPromptAddForm(true);
  };

  const openPromptforConversationHandler = () => {
    setOpenPromptforConversation(!openPromptforConversation);
  };

  const handleCallDialerOpen = () => {
    setOpenCallDialer(true);
  };
  const handleCallDialerClose = () => {
    setOpenCallDialer(false);
  };

  //in-app messages group chat code

  // Helper — derive once, reused in both open handlers and save
  const getAdminEmployeeIds = () =>
    employeeDirectory
      .filter((emp) => emp.role?.toLowerCase() === "admin")
      .map((emp) => String(emp.id));
  const handleOpenAddGroup = () => {
    if (
      !(
        isCurrentUserAdmin ||
        (isAuthenticated &&
          user["https://propertydek.com/permissions"].indexOf(
            "smschat-teamchatgroup:create"
          ) > -1)
      )
    ) {
      setSnackbarOpen(true);
      setSnackbarMsg("Only admins can create groups.");
      return;
    }
    if (!identityClientReady) {
      setSnackbarOpen(true);
      setSnackbarMsg("Chat is still connecting, please try again in a moment.");
      return;
    }
    setGroupModalMode("add");
    setGroupNameInput("");
    setGroupNameError("");
    setSelectedEmployees(getAdminEmployeeIds()); // admins pre-selected on a fresh group
    setEditingGroup(null);
    setOpenGroupModal(true);
  };

  const handleOpenEditGroup = (group) => {
    setGroupModalMode("edit");
    setGroupNameInput(group.name || "");
    setGroupNameError("");
    const existingNonSelf = (group.memberIds || [])
      .map(String)
      .filter((id) => id !== String(userInfo?.id));
    const adminIds = getAdminEmployeeIds();
    // Union — existing members plus any admin not already there
    const merged = Array.from(new Set([...existingNonSelf, ...adminIds]));
    setSelectedEmployees(merged);
    setEditingGroup(group);
    setOpenGroupModal(true);
  };
  const handleCloseGroupModal = () => {
    setOpenGroupModal(false);
    setGroupNameError("");
  };

  const toggleEmployeeSelection = (empId) => {
    const idStr = String(empId);
    setSelectedEmployees((prev) =>
      prev.map(String).includes(idStr)
        ? prev.filter((id) => String(id) !== idStr)
        : [...prev, idStr]
    );
  };
  const handleSaveGroup = async () => {
    if (!identityClientRef.current || !userInfo?.id) return;
    if (!identityClientReady) {
      setSnackbarOpen(true);
      setSnackbarMsg("Chat is still connecting, please try again in a moment.");
      return;
    }

    const trimmedName = groupNameInput.trim();
    if (!trimmedName) {
      setGroupNameError("Please enter a group name.");
      return;
    }
    if (selectedEmployees.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please select at least one member.");
      return;
    }

    setIsSavingGroup(true);
    try {
      if (groupModalMode === "add") {
        const uniqueName = `grp_${Date.now()}_${Math.random()
          .toString(36)
          .slice(2, 8)}`;

        const created = await identityClientRef.current.createConversation({
          uniqueName,
          friendlyName: trimmedName,
        });

        // Refetch to get a fully-synced conversation object before mutating participants
        const conversation = await identityClientRef.current.getConversationBySid(
          created.sid
        );

        await conversation.add(String(userInfo.id));

        const adminIds = getAdminEmployeeIds();
        const finalSelectedEmployees = Array.from(
          new Set([...selectedEmployees.map(String), ...adminIds])
        );

        for (const empId of finalSelectedEmployees) {
          try {
            await conversation.add(String(empId));
          } catch (memberError) {
            throw memberError; // still surface it — don't silently continue for now
          }
        }
      } else {
        const conversation = editingGroup._conversation;

        if (conversation.friendlyName !== trimmedName) {
          await conversation.updateFriendlyName(trimmedName);
        }

        const adminIds = getAdminEmployeeIds();
        const finalSelectedEmployees = Array.from(
          new Set([...selectedEmployees.map(String), ...adminIds])
        );

        const currentIds = (editingGroup.memberIds || []).map(String);
        const desiredIds = [
          String(userInfo.id),
          ...finalSelectedEmployees, // was selectedEmployees.map(String)
        ];

        const toAdd = desiredIds.filter((id) => !currentIds.includes(id));
        const toRemove = currentIds.filter(
          (id) => !desiredIds.includes(id) && id !== String(userInfo.id)
        );

        for (const id of toAdd) {
          await conversation.add(id);
        }
        for (const id of toRemove) {
          const participant = await conversation.getParticipantByIdentity(id);
          if (participant) await conversation.removeParticipant(participant);
        }
      }

      await loadGroupConversations();
      await loadEmployeeGroupsUnreadList();
      setOpenGroupModal(false);
    } catch (error) {
      setSnackbarOpen(true);
      setSnackbarMsg(
        "Something went wrong saving the group. Only group creator can edit the group"
      );
    } finally {
      setIsSavingGroup(false);
    }
  };
  const handleDeleteGroup = async (conversationId) => {
    console.log("[SET-CONVO] via conversation-removed handler -> null");
    const group = groupList.find((g) => g.id === conversationId);
    if (!group) return;

    if (!identityClientReady) {
      setSnackbarOpen(true);
      setSnackbarMsg("Chat is still connecting, please try again in a moment.");
      return;
    }

    try {
      await group._conversation.delete();
      await loadGroupConversations();
      await loadEmployeeGroupsUnreadList();

      // If we were viewing the group we just deleted, back out to the list
      if (activeIdentityConversation?.sid === conversationId) {
        setIsShowIdentityChatMessages(false);
        setActiveIdentityConversation(null);
        setActiveIdentityChatPartner(null);
      }
    } catch (error) {
      setSnackbarOpen(true);
      setSnackbarMsg("Only group creator can delete the group.");
    }
  };

  const refreshGroupsAndConversations = async () => {
    await Promise.all([
      loadGroupConversations(),
      loadEmployeeGroupsUnreadList(),
    ]);
  };
  const handleEmployeeOrGroupSelect = (clicked) => {
    if (clicked.type === "Group") {
      const found = groupList.find((g) => g.id === clicked.conversation_id);
      if (found) setDetailsForGroup(found);
    } else if (clicked.type === "Employee") {
      const found = employeeDirectory.find(
        (e) => String(e.id) === String(clicked.conversation_id)
      );
      if (found) {
        setActiveIdentityChatPartner({
          conversation_id: found.id,
          name: found.name,
          first_name: found.first_name,
          last_name: found.last_name,
          property: found.property,
          role: found.role,
          job_title: found.job_title,
          phone: found.phone,
          type: "Employee",
          status: found.online ? "Online" : "Offline",
        });
        setDetailsForIdentityChat(found);
      }
    }
  };

  const handleSelectAttachment = (file) => {
    if (file.size > MAX_ATTACHMENT_SIZE) {
      setSnackbarOpen(true);
      setSnackbarMsg("File is too large. Please select a file under 50MB.");
      return;
    }
    // No type restriction — any file is allowed now

    setPendingAttachment({
      file,
      name: file.name,
      type: file.type,
      previewUrl: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null,
    });
  };

  const handleCancelAttachment = () => {
    if (pendingAttachment?.previewUrl) {
      URL.revokeObjectURL(pendingAttachment.previewUrl);
    }
    setPendingAttachment(null);
  };

  const typingDisplayText = (() => {
    if (typingIdentities.length === 0) return null;
    const names = typingIdentities
      .filter((id) => String(id) !== String(userInfo?.id)) // never show yourself
      .map((id) => {
        const dir = employeeDirectory.find((e) => String(e.id) === String(id));
        return dir ? dir.name : id;
      });

    if (names.length === 0) return null;
    if (names.length === 1) return `${names[0]} is typing…`;
    if (names.length === 2) return `${names[0]} and ${names[1]} are typing…`;
    return `${names.length} people are typing…`;
  })();

  const handleSelectRecordedAudio = (file, errorMessage) => {
    if (errorMessage) {
      setSnackbarOpen(true);
      setSnackbarMsg(errorMessage);
      return;
    }
    if (!file) return;

    setPendingAttachment({
      file,
      name: file.name,
      type: file.type,
      previewUrl: null, // audio doesn't need an image preview
    });
  };

  const postCallLogMessage = async (otherIdentity, logText) => {
    try {
      const ids = [String(userInfo.id), String(otherIdentity)].sort(
        (a, b) => Number(a) - Number(b)
      );
      const uniqueName = `dm_${ids[0]}_${ids[1]}`;

      let conversation;
      try {
        conversation = await identityClientRef.current.getConversationByUniqueName(
          uniqueName
        );
      } catch (lookupError) {
        // First-ever interaction between these two — no conversation exists yet, create it
        conversation = await identityClientRef.current.createConversation({
          uniqueName,
        });
        await conversation.add(String(userInfo.id));
        await conversation.add(String(otherIdentity));
      }

      await conversation.sendMessage(logText);
      await conversation.setAllMessagesRead();
      refreshGroupsAndConversations();
    } catch (error) {
      console.log("postCallLogMessage failed", error);
    }
  };

  const handleIdentityCallEnded = (outcome, durationSeconds) => {
    if (!isOutgoingCall) return; // ADD THIS — only the caller logs the call

    const identity = activeIdentityCallPartnerIdentityRef.current;

    if (!identity) {
      return;
    }

    if (outcome === "completed") {
      const mins = Math.floor(durationSeconds / 60);
      const secs = durationSeconds % 60;
      postCallLogMessage(
        identity,
        `📞 Voice call · ${mins}: ${secs.toString().padStart(2, "0")}`
      );
    } else if (outcome === "no-answer") {
      postCallLogMessage(identity, "📞 Missed call");
    } else if (outcome === "failed") {
      postCallLogMessage(identity, "📞 Call failed");
      setSnackbarOpen(true);
      setSnackbarMsg("The call couldn't connect. Please try again.");
    }
  };

  const resolveIncomingCallerName = (rawFrom) => {
    if (!rawFrom) return "Unknown caller";
    const identity = rawFrom.replace("client:", "");
    return resolveAuthorName(identity);
  };

  const loadOlderIdentityMessages = async () => {
    console.log("[loadOlder] fired", {
      hasMoreOlderMessages,
      isLoadingOlderMessages,
      paginator: messagesPaginatorRef.current,
    });
    const paginator = messagesPaginatorRef.current;
    if (!paginator?.hasPrevPage || isLoadingOlderMessages) return;

    setIsLoadingOlderMessages(true);
    try {
      const olderPage = await paginator.prevPage();
      messagesPaginatorRef.current = olderPage;
      setHasMoreOlderMessages(!!olderPage.hasPrevPage);

      const olderMapped = olderPage.items
        .filter((m) => !loadedMessageSidsRef.current.has(m.sid))
        .map((m) => {
          loadedMessageSidsRef.current.add(m.sid);
          return {
            sid: m.sid,
            author: m.author,
            message: m.body,
            createdAt: m.dateCreated,
            updatedAt: m.dateUpdated,
            reactions: parseReactions(m.attributes), // see note below
            media: mapMessageMedia(m),
            _message: m,
          };
        });

      setIdentityChatMessagesList((prev) => [...olderMapped, ...prev]);
    } catch (error) {
      handleIdentityChatError(error, "loadOlderIdentityMessages");
    } finally {
      setIsLoadingOlderMessages(false);
    }
  };

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  };

  const isSMSChatTenantRead =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf("smschat-tenant:read") >
    -1;
  const isSMSChatTeamRead =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf("smschat-team:read") >
    -1;
  const isSMSChatPromptRead =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf("smschat-prompt:read") >
    -1;
  const isSMSChatCallforwardingRead =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf(
      "smschat-callforwarding:read"
    ) > -1;
  const isSMSChatTeamchatgroupUpdate =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf(
      "smschat-teamchatgroup:update"
    ) > -1;
  const isSMSChatTeamchatgroupDelete =
    isAuthenticated &&
    user["https://propertydek.com/permissions"].indexOf(
      "smschat-teamchatgroup:delete"
    ) > -1;

  return (
    <>
      {isChatVisible && (
        <div
          className={
            isCommunicationChatBoxOpen
              ? `${styles.CommunicationPopupSec} CommunicationPopupSec ${styles.Open} Open`
              : `${styles.CommunicationPopupSec} CommunicationPopupSec`
          }
        >
          <Prompts
            isPromptModalOpen={isPromptModalOpen}
            hanldePromptModal={hanldePromptModal}
            setPromptListForConversation={setPromptListForConversation}
            isShowPromptAddForm={isShowPromptAddForm}
          />

          <CallForward
            isCallForwardModalOpen={isCallForwardModalOpen}
            hanldeCallForwardModal={hanldeCallForwardModal}
          />
          <div className={`${styles.ChatPopBox}`}>
            <div className={`${styles.PopupSecHead}`}>
              <div className={`${styles.DisFlex}`}>
                <div
                  className={`${styles.GlobalCloseBU}`}
                  onClick={communicationChatBoxHandler}
                >
                  <X />
                </div>
                {isShowChatMessages && (
                  <a
                    className={`${styles.AllListBU}`}
                    onClick={() => backToList()}
                  >
                    <ChevronLeft />
                  </a>
                )}
                {isShowIdentityChatMessages && (
                  <a
                    className={`${styles.AllListBU}`}
                    onClick={backToListFromIdentityChat}
                  >
                    <ChevronLeft />
                  </a>
                )}
                {!isShowChatMessages && !isShowIdentityChatMessages && (
                  <p>SMS Chat </p>
                )}
                {!isShowChatMessages && !isShowIdentityChatMessages && (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "5px",
                      marginLeft: "10px",
                      fontSize: "12px",
                      color: "#fff",
                      background: twilioDown
                        ? "rgba(220,50,50,0.3)"
                        : "rgba(76,175,80,0.3)",
                      padding: "3px 10px",
                      borderRadius: "12px",
                    }}
                  >
                    <span
                      style={{
                        width: "7px",
                        height: "7px",
                        borderRadius: "50%",
                        background: twilioDown ? "#e23725" : "#4caf50",
                      }}
                    />
                    {twilioDown ? "Twilio: Down" : "Twilio: Up"}
                  </span>
                )}
                {!isShowChatMessages && !isShowIdentityChatMessages && (
                  <>
                    {/* <div className={`${ styles.SMSBUSec }`}>
                    <button className={`${ styles.PromptBU }`} onClick={() => hanldePromptModal(true)}><Plus />Prompts</button>
                    <button className={`${ styles.CallForBU }`} onClick={() => hanldeCallForwardModal(true)}><Plus />Call forward</button>
                  </div> */}
                    <div
                      className={`${styles.GlobalCallBU}`}
                      onClick={handleCallDialerOpen}
                    >
                      <div className={`${styles.ClobalCallIcon}`}>
                        <Phone />
                      </div>
                      <span className={`${styles.ClobalCallText}`}>Call</span>
                    </div>
                    {(isSMSChatTenantRead ||
                      isSMSChatPromptRead ||
                      isSMSChatCallforwardingRead) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            className={`${styles.ActionsBUCard} ProsDrBU`}
                            id="dropdown-basic"
                          >
                            <MoreVertical />
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            className={`${styles.ActionsBUCardList} ActionsBUList`}
                          >
                            {isSMSChatPromptRead && (
                              <Dropdown.Item
                                className={`${styles.ActionsBUCardListItem}`}
                                onClick={() => hanldePromptModal(true)}
                              >
                                <Plus /> Prompts
                              </Dropdown.Item>
                            )}
                            {isSMSChatTenantRead && (
                              <Dropdown.Item
                                className={
                                  !isShowChatMessages &&
                                    !isShowIdentityChatMessages
                                    ? `${styles.ActionsBUCardListItem} ${styles.Disabled}`
                                    : `${styles.ActionsBUCardListItem}`
                                }
                              >
                                <Send /> Prompts
                              </Dropdown.Item>
                            )}
                            {isSMSChatCallforwardingRead && (
                              <Dropdown.Item
                                className={`${styles.ActionsBUCardListItem}`}
                                onClick={() => hanldeCallForwardModal(true)}
                              >
                                <PhoneIncoming /> Forward Calls
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                  </>
                )}
                {!isShowChatMessages && !isShowIdentityChatMessages && (
                  <div
                    className={`${styles.MobileCloseBU}`}
                    onClick={communicationChatBoxHandler}
                  >
                    <X />
                  </div>
                )}
                {isShowChatMessages && !isShowPropertyChatMessages && (
                  <div className={`${styles.ChatDeHeadRow}`}>
                    {prospectTenantNames &&
                      prospectTenantNames.slice(0, 1).map((pt, i) => {
                        return (
                          <p key={i} className={`${styles.ChatDeHeadName}`}>
                            {pt?.type === "Prospect" && (
                              <span>
                                <Link to={`/people/prospects/details/${pt.id}`}>
                                  {pt.first_name
                                    ? pt.first_name + " " + pt.last_name
                                    : pt.phone}
                                </Link>
                              </span>
                            )}
                            {pt?.type === "Tenant" && (
                              <span>
                                <Link
                                  to={`/people/tenants/details/${pt.tenant_id}`}
                                >
                                  {pt.first_name
                                    ? pt.first_name + " " + pt.last_name
                                    : pt.phone}
                                </Link>
                              </span>
                            )}
                            {/* ADD THIS */}
                            {pt?.type === "Employee" && (
                              <span>
                                <Link to={`/hr/employees`}>
                                  {pt.first_name
                                    ? pt.first_name + " " + pt.last_name
                                    : pt.phone}
                                </Link>
                              </span>
                            )}
                            {prospectTenantNames.length > 1 && ","}&nbsp;
                            {prospectTenantNames.length > 2 && (
                              <BootstrapTooltip
                                title={prospectTenantNamesForToolTip}
                              >
                                +{prospectTenantNames.length - 1}
                                {pt.type === "Tenant" ? "Tenant" : "Prospect"}
                              </BootstrapTooltip>
                            )}
                            {/*prospectTenantNames.length > 2 && (
                              <BootstrapTooltip
                                title={prospectTenantNamesForToolTip}
                              >
                                {prospectTenantNamesForToolTip.length}{" "}
                                {pt.type === "Tenant" ? "Tenants" : "Prospects"}
                              </BootstrapTooltip>
                            )*/}
                            {pt.type === "Tenant" && (
                              <img
                                src="/static/img/verified.svg"
                                className={`${styles.VarifiedBadgeTenantChatHead}`}
                                alt=""
                              />
                            )}
                            {pt.type === "Prospect" &&
                              pt?.current_status === 0 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.NotApplied}`}
                                >
                                  Not Applied
                                </span>
                              )}
                            {pt.type === "Prospect" &&
                              pt?.current_status === 1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Applied}`}
                                >
                                  Applied
                                </span>
                              )}
                            {pt.type === "Prospect" &&
                              pt?.current_status === 2 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Screened}`}
                                >
                                  Screened
                                </span>
                              )}
                            {pt.type === "Prospect" &&
                              pt?.current_status === 3 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Approved}`}
                                >
                                  Approved
                                </span>
                              )}
                            {pt.type === "Prospect" &&
                              pt?.current_status === 4 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Declined}`}
                                >
                                  Declined
                                </span>
                              )}
                            {(isSMSChatTenantRead ||
                              isSMSChatPromptRead ||
                              isSMSChatCallforwardingRead) && (
                                <Dropdown className={`${styles.MarLeftAuto}`}>
                                  <Dropdown.Toggle
                                    className={`${styles.ActionsBUCard} ProsDrBU`}
                                    id="dropdown-basic"
                                  >
                                    <MoreVertical />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu
                                    className={`${styles.ActionsBUCardList} ActionsBUList`}
                                  >
                                    {isSMSChatPromptRead && (
                                      <Dropdown.Item
                                        className={`${styles.ActionsBUCardListItem}`}
                                        onClick={() => hanldePromptModal(true)}
                                      >
                                        <Plus /> Prompts
                                      </Dropdown.Item>
                                    )}
                                    {isSMSChatTenantRead && (
                                      <Dropdown.Item
                                        className={`${styles.ActionsBUCardListItem}`}
                                        onClick={openPromptforConversationHandler}
                                      >
                                        <Send /> Prompts
                                      </Dropdown.Item>
                                    )}
                                    {isSMSChatTenantRead && (
                                      <Dropdown.Item
                                        className={`${styles.ActionsBUCardListItem}`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          initiateVoiceCall(
                                            prospectTenantNames[0]
                                          );
                                        }}
                                      >
                                        <PhoneCall /> Call {pt?.type}
                                      </Dropdown.Item>
                                    )}
                                    {isSMSChatCallforwardingRead && (
                                      <Dropdown.Item
                                        className={`${styles.ActionsBUCardListItem}`}
                                        onClick={() =>
                                          hanldeCallForwardModal(true)
                                        }
                                      >
                                        <PhoneIncoming /> Forward Calls
                                      </Dropdown.Item>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}
                          </p>
                        );
                      })}
                    {prospectTenantNames &&
                      prospectTenantNames.length > 0 &&
                      prospectTenantNames[0]?.property_name && (
                        <div className={`${styles.SubHeadSec}`}>
                          <p className={`${styles.ChatDeHeadDetails}`}>
                            <span>{prospectTenantNames[0]?.property_name}</span>

                            {prospectTenantNames[0]?.type !== "Employee" && (
                              <span>{prospectTenantNames[0]?.apt_no}</span>
                            )}
                            {prospectTenantNames[0]?.type === "Employee" && (
                              <span>{prospectTenantNames[0]?.role}</span>
                            )}
                          </p>
                          {prospectTenantNames[0].unread_no > 0 && (
                            <button
                              className={`${styles.MarkReadBU}`}
                              onClick={() =>
                                markAsReadConversationMessages(
                                  prospectTenantNames[0]?.conversation_id
                                )
                              }
                            >
                              Mark as read
                            </button>
                          )}
                        </div>
                      )}
                  </div>
                )}
                {isShowChatMessages && isShowPropertyChatMessages && (
                  <div className={`${styles.ChatDeHeadRow}`}>
                    <p className={`${styles.ChatDeHeadName}`}>
                      <span>
                        <a>All Tenants</a>
                      </span>
                      {(isSMSChatTenantRead ||
                        isSMSChatPromptRead ||
                        isSMSChatCallforwardingRead) && (
                          <Dropdown className={`${styles.MarLeftAuto}`}>
                            <Dropdown.Toggle
                              className={`${styles.ActionsBUCard} ProsDrBU`}
                              id="dropdown-basic"
                            >
                              <MoreVertical />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              className={`${styles.ActionsBUCardList} ActionsBUList`}
                            >
                              {isSMSChatPromptRead && (
                                <Dropdown.Item
                                  className={`${styles.ActionsBUCardListItem}`}
                                  onClick={() => hanldePromptModal(true)}
                                >
                                  <Plus /> Prompts
                                </Dropdown.Item>
                              )}
                              {isSMSChatTenantRead && (
                                <Dropdown.Item
                                  className={`${styles.ActionsBUCardListItem}`}
                                  onClick={openPromptforConversationHandler}
                                >
                                  <Send /> Prompts
                                </Dropdown.Item>
                              )}

                              {isSMSChatCallforwardingRead && (
                                <Dropdown.Item
                                  className={`${styles.ActionsBUCardListItem}`}
                                  onClick={() => hanldeCallForwardModal(true)}
                                >
                                  <PhoneIncoming /> Forward Calls
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                    </p>
                    <div className={`${styles.SubHeadSec}`}>
                      <p className={`${styles.ChatDeHeadDetails}`}>
                        <span>{prospectTenantDetails?.propertyName}</span>
                        {prospectTenantDetails?.floor &&
                          prospectTenantDetails?.floor === 1 && (
                            <span>1st Floor</span>
                          )}
                        {prospectTenantDetails?.floor &&
                          prospectTenantDetails?.floor === 2 && (
                            <span>2nd Floor</span>
                          )}
                        {prospectTenantDetails?.floor &&
                          prospectTenantDetails?.floor === 3 && (
                            <span>3rd Floor</span>
                          )}
                        {prospectTenantDetails?.floor &&
                          prospectTenantDetails?.floor === 4 && (
                            <span>4th Floor</span>
                          )}
                        {prospectTenantDetails?.floor &&
                          prospectTenantDetails?.floor === 5 && (
                            <span>5th Floor</span>
                          )}

                        {/* <span>All Tenants</span> */}
                      </p>
                    </div>
                  </div>
                )}

                {isShowIdentityChatMessages && (
                  <div className={`${styles.ChatDeHeadRow}`}>
                    <p className={`${styles.ChatDeHeadName}`}>
                      {activeIdentityChatPartner?.name}
                      {activeIdentityChatPartner?.type === "Group" && (
                        <span
                          className={`${styles.StatusBadgeChatHead} ${styles.GroupStatusBadge}`}
                        >
                          Group Chat
                        </span>
                      )}
                      {activeIdentityChatPartner?.type === "Employee" && (
                        <span
                          className={`${styles.StatusBadgeChatHead}`}
                          style={{
                            background:
                              activeIdentityChatPartner.status === "Online"
                                ? "#4caf50"
                                : "#9e9e9e",
                          }}
                        >
                          {activeIdentityChatPartner.status}
                        </span>
                      )}
                      {((activeIdentityChatPartner?.type === "Group" &&
                        isCurrentUserAdmin) ||
                        activeIdentityChatPartner?.type === "Employee" ||
                        isSMSChatTeamchatgroupUpdate ||
                        isSMSChatTeamchatgroupDelete) && (
                          <Dropdown
                            className={`${styles.AlignRight}`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Dropdown.Toggle
                              className={`${styles.ActionsBUCard} ProsDrBU`}
                              id="dropdown-basic"
                            >
                              <MoreVertical />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              className={`${styles.ActionsBUCardList} ActionsBUList`}
                            >
                              {activeIdentityChatPartner?.type === "Group" && (
                                <>
                                  {isSMSChatTeamchatgroupUpdate && (
                                    <Dropdown.Item
                                      className={`${styles.ActionsBUCardListItem}`}
                                      onClick={() =>
                                        handleOpenEditGroup(
                                          groupList.find(
                                            (g) =>
                                              g.id ===
                                              activeIdentityChatPartner.conversation_id
                                          )
                                        )
                                      }
                                    >
                                      <Edit /> Edit
                                    </Dropdown.Item>
                                  )}
                                  {isSMSChatTeamchatgroupDelete && (
                                    <Dropdown.Item
                                      className={`${styles.ActionsBUCardListItem}`}
                                      onClick={() => {
                                        setGroupIdToDelete(
                                          activeIdentityChatPartner.conversation_id
                                        );
                                        setOpenDeleteGroupConfirmModal(true);
                                      }}
                                    >
                                      <Trash2 /> Delete
                                    </Dropdown.Item>
                                  )}
                                </>
                              )}
                              {activeIdentityChatPartner?.type === "Employee" && (
                                <Dropdown.Item
                                  className={`${styles.ActionsBUCardListItem}`}
                                  onClick={() =>
                                    initiateInAppVoiceCall(
                                      activeIdentityChatPartner
                                    )
                                  }
                                >
                                  <PhoneCall /> Call
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                    </p>
                    <p className={`${styles.ChatDeHeadDetails}`}>
                      {typingDisplayText ? (
                        <span style={{ fontStyle: "italic" }}>
                          {typingDisplayText}
                        </span>
                      ) : (
                        <>
                          {/* <span>{activeIdentityChatPartner?.property}</span>*/}
                          {activeIdentityChatPartner?.type === "Group" &&
                            activeIdentityChatPartner?.members && (
                              <span>
                                {(() => {
                                  const names = activeIdentityChatPartner.members.split(
                                    ", "
                                  );
                                  if (names.length <= 2)
                                    return activeIdentityChatPartner.members;
                                  return `${names.slice(0, 2).join(", ")} + ${names.length - 2
                                    }`;
                                })()}
                              </span>
                            )}
                          {activeIdentityChatPartner?.type !== "Group" && (
                            <span>{activeIdentityChatPartner?.job_title}</span>
                          )}
                        </>
                      )}
                    </p>
                  </div>
                )}
              </div>

              {openCallDialer && (
                <CallDialer
                  handleCallDialerClose={handleCallDialerClose}
                  initiateVoiceCallByDialPad={initiateVoiceCallByDialPad}
                />
              )}

              {!isShowChatMessages && !isShowIdentityChatMessages && (
                <div className={`${styles.TabWithSearch}`}>
                  <div className={`${styles.PopupSecHeadTabSec}`}>
                    {isSMSChatTenantRead && (
                      <button
                        onClick={() => tabHandler("globalListTab")}
                        className={
                          isShowGlobalList === true ? `${styles.Active}` : ""
                        }
                      >
                        <span>Directory</span>
                      </button>
                    )}
                    {isSMSChatTenantRead && (
                      <button
                        onClick={() => tabHandler("unreadMessageTab")}
                        className={
                          isShowUnreadMessageList === true
                            ? `${styles.Active}`
                            : ""
                        }
                      >
                        <span>Messages</span>
                        {unreadMessagesCounter > 0 && (
                          <span className={`${styles.UnreadCounter}`}>
                            {unreadMessagesCounter}
                          </span>
                        )}
                      </button>
                    )}
                    {isSMSChatTeamRead && (
                      <button
                        onClick={() => tabHandler("teamTab")}
                        className={
                          isShowTeamTab === true ? `${styles.Active}` : ""
                        }
                      >
                        <span>Team</span>
                        {employeeGroupsTotalUnread + assignedTenantUnreadCount >
                          0 && (
                            <span className={`${styles.UnreadCounter}`}>
                              {employeeGroupsTotalUnread +
                                assignedTenantUnreadCount}
                            </span>
                          )}
                      </button>
                    )}
                  </div>
                  {(isSMSChatTenantRead || isSMSChatTeamRead) && (
                    <div
                      className={`${styles.SearchBU}`}
                      onClick={handleSearchToggle}
                    >
                      <Search />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className={`${styles.PopupSecBody} PopupSecBody`}>
              {/* {twilioDown ? (
                <div className={`${ styles.MessageError }`}>
                  <AlertTriangle />
                  <TwilioDownBanner twilioStatusMsg={twilioStatusMsg} />
                  <button
                    className={`${ styles.CloseBUTwilioDown }`}
                    onClick={() => {
                      setTwilioDown(false);
                      setTwilioStatusMsg("");
                    }}
                  >
                    <X />
                  </button>
                </div>
              ) : null} */}
              {!isShowChatMessages &&
                !isShowIdentityChatMessages &&
                !isShowTeamTab && (
                  <ProspectTenantSearch
                    onSelectTypeahead={onSelectTypeahead}
                    typeaheadProspectTenantList={typeaheadProspectTenantList}
                    filterByCallback={filterByCallback}
                    employeeDirectory={employeeDirectory}
                    onSelectEmployeeTypeahead={handleGlobalEmployeeSelect}
                    showSearch={showSearch}
                  />
                )}
              {!isShowChatMessages && !isShowIdentityChatMessages && (
                <div className={` ${styles.PopupContent}`}>
                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowGlobalList && (
                      <ProspectList
                        toggleAccordionForProspect={toggleAccordionForProspect}
                        accordionOnForProspect={accordionOnForProspect}
                        prospectTenantDetails={prospectTenantDetails}
                        setDetails={setDetails}
                        prospectList={prospectList}
                      />
                    )}
                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowGlobalList && (
                      <TenantList
                        toggleAccordionForTenant={toggleAccordionForTenant}
                        accordionOnForTenant={accordionOnForTenant}
                        selectedProperty={selectedProperty}
                        prospectTenantDetails={prospectTenantDetails}
                        setDetails={setDetails}
                        tenantList={tenantList}
                        typeaheadProspectTenantList={
                          typeaheadProspectTenantList
                        }
                        setSnackbarOpen={setSnackbarOpen}
                        setSnackbarMsg={setSnackbarMsg}
                        setDetailsForPropertiesChat={
                          setDetailsForPropertiesChat
                        }
                      />
                    )}

                  {/* {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowGlobalList && (
                      <EmployeeList
                        employeeList={employeeList}
                        accordionOnForEmployee={accordionOnForEmployee}
                        toggleAccordionForEmployee={toggleAccordionForEmployee}
                        setDetails={setDetailsForEmployee}
                        prospectTenantDetails={prospectTenantDetails}
                      />
                    )} */}

                  {/* {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    (isShowGlobalList || isShowUnreadMessageList) && (
                      <EmployeeList
                        groups={groupList}
                        employees={employeeDirectory}
                        accordionOnForEmployee={accordionOnForEmployee}
                        toggleAccordionForEmployee={toggleAccordionForEmployee}
                        setDetails={handleEmployeeOrGroupSelect}
                        onAddGroup={() =>
                          console.log("Add Group — modal not built yet")
                        }
                        prospectTenantDetails={prospectTenantDetails}
                      />
                    )} */}

                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowGlobalList && (
                      <EmployeeGlobalList
                        employees={employeeDirectory}
                        accordionOnForEmployee={accordionOnForEmployee}
                        toggleAccordionForEmployee={toggleAccordionForEmployee}
                        onSelectEmployee={handleGlobalEmployeeSelect}
                      />
                    )}

                  {/* {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowUnreadMessageList && (
                      <EmployeeGroupsUnread
                        items={employeeGroupsUnreadList}
                        totalUnread={employeeGroupsTotalUnread}
                        accordionOnForEmployee={accordionOnForEmployeeUnRead}
                        toggleAccordionForEmployee={
                          toggleAccordionForEmployeeUnRead
                        }
                        onSelect={handleEmployeeGroupsUnreadSelect}
                        onAddGroup={handleOpenAddGroup}
                      />
                    )} */}

                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowTeamTab && (
                      <>
                        <AssignedTenantConversations
                          items={assignedTenantConversations}
                          onSelect={onSelectAssignedTenantConversation}
                        />

                        <EmployeeGroupsUnread
                          items={employeeGroupsUnreadList}
                          onSelect={handleEmployeeGroupsUnreadSelect}
                          onAddGroup={handleOpenAddGroup}
                          canManageGroups={isCurrentUserAdmin}
                        />
                      </>
                    )}
                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowUnreadMessageList && (
                      <ProspectListunread
                        toggleAccordionForProspectUnRead={
                          toggleAccordionForProspectUnRead
                        }
                        accordionOnForProspectUnRead={
                          accordionOnForProspectUnRead
                        }
                        prospectTenantDetails={prospectTenantDetails}
                        setDetails={setDetails}
                        unreadMessageList={unreadMessageList}
                      />
                    )}
                  {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowUnreadMessageList && (
                      <TenantListunread
                        toggleAccordionForTenantUnRead={
                          toggleAccordionForTenantUnRead
                        }
                        accordionOnForTenantUnRead={accordionOnForTenantUnRead}
                        prospectTenantDetails={prospectTenantDetails}
                        setDetails={setDetails}
                        unreadMessageList={unreadMessageList}
                      />
                    )}

                  {/* {!isShowChatMessages &&
                    !isShowIdentityChatMessages &&
                    isShowUnreadMessageList && (
                      <EmployeeListunread
                        accordionOnForEmployeeUnRead={
                          accordionOnForEmployeeUnRead
                        }
                        toggleAccordionForEmployeeUnRead={
                          toggleAccordionForEmployeeUnRead
                        }
                        setDetails={setDetailsForEmployee}
                        prospectTenantDetails={prospectTenantDetails}
                        unreadMessageList={unreadMessageList}
                      />
                    )} */}

                  {/* {!isShowChatMessages && isShowUnreadMessageList && (
                  <UnreadMessagesList
                    unreadMessageList={unreadMessageList}
                    prospectTenantDetails={prospectTenantDetails}
                    setDetails={setDetails}
                  />
                )} */}
                </div>
              )}
              {isShowChatMessages && (
                <div className={` ${styles.PopupContentMessageSec}`}>
                  <ChatMessages
                    messageLoader={messageLoader}
                    chatMessagesList={chatMessagesList}
                    prospectTenantNames={prospectTenantNames}
                    unreadMessageList={unreadMessageList}
                  />
                  <ChatInputBox
                    messageTextVal={messageTextVal}
                    handleChange={handleChange}
                    sendMessage={
                      isShowPropertyChatMessages
                        ? sendMessageForPropertiesChat
                        : sendMessage
                    }
                  />

                  <PromptsForConversation
                    list={promptListForConversation}
                    handlePromptClick={handlePromptClick}
                    hanldePromptModalForConversation={
                      hanldePromptModalForConversation
                    }
                    openPromptforConversationHandler={
                      openPromptforConversationHandler
                    }
                    openPromptforConversation={openPromptforConversation}
                  />
                </div>
              )}

              {isShowIdentityChatMessages && (
                <div className={` ${styles.PopupContentMessageSec}`}>
                  <IdentityChatMessages
                    messages={identityChatMessagesList}
                    messageLoader={identityMessageLoader}
                    currentUserId={userInfo?.id}
                    resolveAuthorName={resolveAuthorName}
                    onEditMessage={editIdentityChatMessage}
                    onToggleReaction={toggleMessageReaction}
                    onLoadOlderMessages={loadOlderIdentityMessages} // NEW
                    hasMoreOlderMessages={hasMoreOlderMessages} // NEW
                    isLoadingOlderMessages={isLoadingOlderMessages} // NEW
                  />
                  <IdentityChatInputBox
                    messageTextVal={identityMessageTextVal}
                    handleChange={handleIdentityChatChange}
                    sendMessage={sendIdentityChatMessage}
                    pendingAttachment={pendingAttachment}
                    onSelectFile={handleSelectAttachment}
                    onSelectRecordedAudio={handleSelectRecordedAudio}
                    onCancelAttachment={handleCancelAttachment}
                    isUploading={isUploadingAttachment}
                  />
                </div>
              )}
            </div>
          </div>
          {isShowCommunicationChat && (
            <div
              onClick={communicationChatBoxHandler}
              className={`${styles.ChatBoxOpenBU}`}
            >
              <div className={`${styles.BUOpen}`}>
                {unreadMessagesCounter > 0 && (
                  <span className={`${styles.ChatBoxOpenBUCounter}`}>
                    {unreadMessagesCounter}
                  </span>
                )}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="30"
                  viewBox="0 0 39 37"
                  class="conversations-visitor-open-icon"
                >
                  <defs>
                    <path
                      id="conversations-visitor-open-icon-path-1:r0:"
                      d="M31.4824242 24.6256121L31.4824242 0.501369697 0.476266667 0.501369697 0.476266667 24.6256121z"
                    ></path>
                  </defs>
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="none"
                    stroke-width="1"
                  >
                    <g transform="translate(-1432 -977) translate(1415.723 959.455)">
                      <g transform="translate(17 17)">
                        <g transform="translate(6.333 .075)">
                          <path
                            fill="#ffffff"
                            d="M30.594 4.773c-.314-1.943-1.486-3.113-3.374-3.38C27.174 1.382 22.576.5 15.36.5c-7.214 0-11.812.882-11.843.889-1.477.21-2.507.967-3.042 2.192a83.103 83.103 0 019.312-.503c6.994 0 11.647.804 12.33.93 3.079.462 5.22 2.598 5.738 5.728.224 1.02.932 4.606.932 8.887 0 2.292-.206 4.395-.428 6.002 1.22-.516 1.988-1.55 2.23-3.044.008-.037.893-3.814.893-8.415 0-4.6-.885-8.377-.89-8.394"
                          ></path>
                        </g>
                        <g fill="#ffffff" transform="translate(0 5.832)">
                          <path d="M31.354 4.473c-.314-1.944-1.487-3.114-3.374-3.382-.046-.01-4.644-.89-11.859-.89-7.214 0-11.813.88-11.843.888-1.903.27-3.075 1.44-3.384 3.363C.884 4.489 0 8.266 0 12.867c0 4.6.884 8.377.889 8.393.314 1.944 1.486 3.114 3.374 3.382.037.007 3.02.578 7.933.801l2.928 5.072a1.151 1.151 0 001.994 0l2.929-5.071c4.913-.224 7.893-.794 7.918-.8 1.902-.27 3.075-1.44 3.384-3.363.01-.037.893-3.814.893-8.414 0-4.601-.884-8.378-.888-8.394"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div className={`${styles.BUClose}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 19 18"
                  class="conversations-visitor-close-icon"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="none"
                    stroke-width="1"
                  >
                    <g
                      fill="#ffffff"
                      transform="translate(-927 -991) translate(900.277 962)"
                    >
                      <g transform="translate(27 29)">
                        <path d="M10.627 9.013l6.872 6.873.708.707-1.415 1.414-.707-.707-6.872-6.872L2.34 17.3l-.707.707L.22 16.593l.707-.707L7.8 9.013.946 2.161l-.707-.708L1.653.04l.707.707L9.213 7.6 16.066.746l.707-.707 1.414 1.414-.707.708-6.853 6.852z"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          )}
        </div>
      )}

      <Dialog
        open={openCallModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenCallModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">
          {prospectInfoObj?.type} Call Confirmation
          <button onClick={(e) => setOpenCallModal(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">
                Please confirm you wish to initiate a call to this{" "}
                {prospectInfoObj?.type}.
              </label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => setOpenCallModal(false)}
            className="CancelPopupBU"
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => initiateVoiceCallConfirm()}
            className="SubmitPopupBU"
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteGroupConfirmModal}
        fullWidth
        maxWidth="sm"
        onClose={() => setOpenDeleteGroupConfirmModal(false)}
        aria-labelledby="delete-group-dialog-title"
        aria-describedby="delete-group-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="delete-group-dialog-title">
          Delete Group Confirmation
          <button onClick={() => setOpenDeleteGroupConfirmModal(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-group-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">
                Are you sure you want to delete this group? This action cannot
                be undone.
              </label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDeleteGroupConfirmModal(false)}
            className="CancelPopupBU"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (groupIdToDelete) {
                handleDeleteGroup(groupIdToDelete);
              }
              setOpenDeleteGroupConfirmModal(false);
            }}
            className="SubmitPopupBU"
            style={{ background: "#ff8271", borderColor: "#ff8271" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openGroupModal}
        onClose={handleCloseGroupModal}
        maxWidth="sm"
        fullWidth
        aria-labelledby="group-dialog-title"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="group-dialog-title">
          <button
            className={`${styles.BackAddBU}`}
            onClick={handleCloseGroupModal}
          >
            <ArrowLeft />
          </button>
          {groupModalMode === "add" ? "Create New Group" : "Edit Group"}
          <button onClick={handleCloseGroupModal}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent
          className={`${styles.RequestBodyPop}`}
          style={{ padding: "10px 0px 0 0" }}
        >
          <div className={`${styles.FormGroupFull} FormGroup`}>
            <TextField
              label="Group Name*"
              variant="outlined"
              fullWidth
              value={groupNameInput}
              onChange={(e) => {
                setGroupNameInput(e.target.value);
                if (groupNameError && e.target.value.trim()) {
                  setGroupNameError("");
                }
              }}
              error={!!groupNameError}
              helperText={groupNameError}
              placeholder="e.g. Maintenance Team"
            />
          </div>

          <label
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#502688",
              marginBottom: "10px",
              display: "block",
            }}
          >
            Select Employees / Members
            <p style={{ fontSize: "12px", color: "#888", margin: "0 0 8px 0" }}>
              All admins are automatically included in every group.
            </p>
          </label>

          <div
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #e1e1e1",
              borderRadius: "8px",
              padding: "10px",
            }}
          >
            {employeeDirectory.map((emp) => {
              const isAdmin = emp.role?.toLowerCase() === "admin";
              const isChecked =
                isAdmin ||
                selectedEmployees.map(String).includes(String(emp.id));
              return (
                <div
                  key={emp.id}
                  onClick={() => !isAdmin && toggleEmployeeSelection(emp.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    cursor: isAdmin ? "default" : "pointer",
                    borderRadius: "6px",
                    background: isChecked ? "#f5f0fc" : "transparent",
                    marginBottom: "4px",
                    transition: "all 0.2s",
                    opacity: isAdmin ? 0.75 : 1,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled={isAdmin}
                    onChange={() => { }}
                    style={{
                      marginRight: "12px",
                      width: "16px",
                      height: "16px",
                      cursor: isAdmin ? "default" : "pointer",
                    }}
                  />
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#f0edf8",
                    }}
                  >
                    {emp.avatar ? (
                      <img
                        src={emp.avatar}
                        alt=""
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#502688",
                        }}
                      >
                        {getInitials(emp.name)}
                      </p>
                    )}
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#343434",
                      }}
                    >
                      {emp.name}
                    </p>
                    <p style={{ margin: 0, fontSize: "12px", color: "#666" }}>
                      {emp.role}
                    </p>
                  </div>
                  {isAdmin && (
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#502688",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Admin
                    </span>
                  )}
                </div>
              );
            })}
          </div>

          <div className={`${styles.ButtonSec}`} style={{ marginTop: "24px" }}>
            <button
              onClick={handleCloseGroupModal}
              className="CancelPopupBU"
              style={{ border: "none", outline: "none" }}
            >
              Cancel
            </button>
            <button
              onClick={handleSaveGroup}
              className="SubmitPopupBU"
              disabled={isSavingGroup}
              style={{
                border: "none",
                outline: "none",
                opacity: isSavingGroup ? 0.6 : 1,
              }}
            >
              {isSavingGroup
                ? "Saving..."
                : groupModalMode === "add"
                  ? "Create Group"
                  : "Save Changes"}
            </button>
          </div>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        onClose={(e) => setSnackbarOpen(false)}
        TransitionComponent={Slide}
        message={snackbarMsg}
        autoHideDuration={10000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(e) => setSnackbarOpen(false)}
          >
            <X />
          </IconButton>
        }
      />

      <IdentityVoiceCallBar
        call={activeIdentityCall}
        callPartnerName={activeIdentityCallPartnerName}
        callPartnerIdentity={activeIdentityCallPartnerIdentity}
        callPartnerAvatar={activeIdentityCallPartnerAvatar}
        onCallEnded={handleIdentityCallEnded}
        onHangup={() => {
          setActiveIdentityCall(null);
          setActiveIdentityCallPartnerName("");
          setActiveIdentityCallPartnerIdentity(null);
          setActiveIdentityCallPartnerAvatar("");
          activeIdentityCallPartnerIdentityRef.current = null;
          setIsOutgoingCall(false); // ADD THIS
        }}
      />

      <IdentityIncomingCallModal
        call={incomingIdentityCall}
        callerName={resolveIncomingCallerName(
          incomingIdentityCall?.parameters?.From
        )}
        onAccept={(call) => {
          const callerIdentity = call?.parameters?.From?.replace("client:", "");
          setActiveIdentityCall(call);
          setActiveIdentityCallPartnerName(resolveAuthorName(callerIdentity));
          setActiveIdentityCallPartnerIdentity(callerIdentity);
          setActiveIdentityCallPartnerAvatar(
            resolveAuthorAvatar(callerIdentity)
          );
          activeIdentityCallPartnerIdentityRef.current = callerIdentity;
          setIsOutgoingCall(false); // ADD THIS
          setIncomingIdentityCall(null);
        }}
        onDecline={() => setIncomingIdentityCall(null)}
      />
    </>
  );
};

export default CommunicationChat;
